import { defineMessages } from 'react-intl'

export default defineMessages({
  account: {
    defaultMessage: 'Account',
    id: 'mercury.account'
  },
  account_ending_in: {
    defaultMessage: 'Account Ending in',
    id: 'mercury.account_ending_in'
  },
  account_iban: {
    defaultMessage: 'IBAN',
    id: 'mercury.account_iban'
  },
  account_number: {
    defaultMessage: 'Account Number',
    id: 'mercury.account_number'
  },
  account_number_upt: {
    defaultMessage: 'Account Number/IBAN',
    id: 'mercury.account_number_upt'
  },
  account_personal_info: {
    defaultMessage: 'Personal Info',
    id: 'mercury.account_personal_info'
  },
  account_restricted: {
    defaultMessage: 'Account Restricted',
    id: 'mercury.account_restricted'
  },
  account_restricted_desc: {
    defaultMessage:
      'Currently, trading is not allowed for balances over €10000 due to regulatory sanctions. However, you can still hold or withdraw.',
    id: 'mercury.account_restricted_desc'
  },
  account_restricted_desc_generic: {
    defaultMessage:
      'Currently, this action is not allowed for balances over €10000 due to regulatory sanctions. However, you can still hold or withdraw.',
    id: 'mercury.account_restricted_desc_generic'
  },
  account_type: {
    defaultMessage: 'Account Type',
    id: 'mercury.account_account_type'
  },
  active: {
    defaultMessage: 'Active',
    id: 'mercury.active'
  },
  add: {
    defaultMessage: 'Add',
    id: 'mercury.add'
  },
  add_a_bank: {
    defaultMessage: 'Add a Bank Account',
    id: 'mercury.add_a_bank'
  },
  add_debit_or_credit: {
    defaultMessage: 'Add Debit or Credit Card',
    id: 'mercury.add_debit_or_credit'
  },
  add_new_bank: {
    defaultMessage: 'Add New Bank',
    id: 'mercury.add_new_bank'
  },
  add_pair: {
    defaultMessage: 'Add Pair',
    id: 'mercury.add_pair'
  },
  address: {
    defaultMessage: 'Address',
    id: 'mercury.address'
  },
  address_management: {
    defaultMessage: 'Address Management',
    id: 'mercury.address_management'
  },
  all: {
    defaultMessage: 'All',
    id: 'mercury.all'
  },
  all_pairs: {
    defaultMessage: 'All Pairs',
    id: 'mercury.all_pairs'
  },
  amount: {
    defaultMessage: 'Amount',
    id: 'mercury.amount'
  },
  android: {
    defaultMessage: 'Android',
    id: 'mercury.android'
  },
  api_button_cancel: {
    defaultMessage: 'Yes, Delete Now',
    id: 'mercury.api_button_cancel'
  },
  api_button_new: {
    defaultMessage: 'Create New API Key Now',
    id: 'mercury.api_button_new'
  },
  api_button_new_2: {
    defaultMessage: 'New API Key',
    id: 'mercury.api_button_new_2'
  },
  api_key_activation: {
    defaultMessage: 'Your key has been created, please check your email to activate this key.',
    id: 'mercury.api_key_activation:'
  },
  api_key_activation_qr_code: {
    defaultMessage:
      'Alternatively you can scan this QR code to add your API key to a 3rd party application.',
    id: 'mercury.api_key_activation_qr_code'
  },
  api_key_delete_sub_title: {
    defaultMessage: 'This cannot be undone.',
    id: 'mercury.api_key_delete_sub_title:'
  },
  api_key_delete_title: {
    defaultMessage: 'Are you sure you want to delete this API key?',
    id: 'mercury.api_key_delete_title'
  },
  api_key_never_reshow_part1: {
    defaultMessage: 'Store your API secret in a safe place. We will',
    id: 'mercury.api_key_never_reshow_part1'
  },
  api_key_never_reshow_part2: {
    defaultMessage: 'NEVER',
    id: 'mercury.api_key_never_reshow_part2'
  },
  api_key_never_reshow_part3: {
    defaultMessage: 'show it again.',
    id: 'mercury.api_key_never_reshow_part3'
  },
  api_key_new: {
    defaultMessage: 'Activate this new API key from your {email} email',
    id: 'mercury.api_key_new'
  },
  api_key_secret: {
    defaultMessage: 'API Secret',
    id: 'mercury.api_key_secret'
  },
  api_key_success: {
    defaultMessage: 'Success!',
    id: 'mercury.api_key_success'
  },
  api_management: {
    defaultMessage: 'API Management',
    id: 'mercury.api_management'
  },
  api_settings_subtitle: {
    defaultMessage: 'My API Keys',
    id: 'mercury.api_settings_subtitle'
  },
  application_complete: {
    defaultMessage: 'Application Complete',
    id: 'mercury.application_complete'
  },
  application_received: {
    defaultMessage:
      'We have received your application. A Blockchain.com Support Member is reviewing your info now.',
    id: 'mercury.application_received'
  },
  apply_now: {
    defaultMessage: 'Apply Now',
    id: 'mercury.apply_now'
  },
  approve_your_deposit: {
    defaultMessage: 'Approve Your Deposit',
    id: 'mercury.approve_your_deposit'
  },
  approved: {
    defaultMessage: 'Approved',
    id: 'mercury.approved'
  },
  auction_imbalance: {
    defaultMessage: 'Imbalance',
    id: 'mercury.auction_imbalance'
  },
  auction_opening_price: {
    defaultMessage: 'Opening Price',
    id: 'mercury.auction_opening_price'
  },
  auction_opening_size: {
    defaultMessage: 'Opening Size',
    id: 'mercury.auction_opening_size'
  },
  auction_opening_time: {
    defaultMessage: 'Opening Time',
    id: 'mercury.auction_opening_time'
  },
  authenticator_app: {
    defaultMessage: 'Authenticator App',
    id: 'mercury.authenticator_app'
  },
  authenticator_app_desc: {
    defaultMessage: 'Use app-generated codes',
    id: 'mercury.authenticator_app_desc'
  },
  authenticator_app_setup1: {
    defaultMessage: 'Scan this QR code with your Authenticator app.',
    id: 'mercury.authenticator_app_setup1'
  },
  authenticator_app_setup2: {
    defaultMessage: 'Enter the code from your authenticator app below.',
    id: 'mercury.authenticator_app_setup2'
  },
  authenticator_app_success: {
    defaultMessage: 'Successfully setup {type}',
    id: 'mercury.authenticator_app_success'
  },
  available: {
    defaultMessage: 'Available',
    id: 'mercury.available'
  },
  available_instant: {
    defaultMessage: 'Instantly Available',
    id: 'mercury.available_instant'
  },
  available_later: {
    defaultMessage: 'Available in 3-5 business days.',
    id: 'mercury.available_later'
  },
  available_payment_methods: {
    defaultMessage: 'Available payment methods',
    id: 'mercury.available_payment_methods'
  },
  back: {
    defaultMessage: 'Back',
    id: 'mercury.back'
  },
  backup_codes: {
    defaultMessage: 'Backup Codes',
    id: 'mercury.backup_codes'
  },
  backup_codes_description: {
    defaultMessage: 'You can use these to login to your account in case you lose your 2FA device.',
    id: 'mercury.backup_codes_description'
  },
  bank_account: {
    defaultMessage: 'Bank Account',
    id: 'bank_account'
  },
  bank_account_remove_subtitle: {
    defaultMessage: 'The following bank account will be deleted: {accountName}',
    id: 'bank_account_remove_subtitle'
  },
  bank_account_remove_title: {
    defaultMessage: 'Do you want to delete this bank account?',
    id: 'bank_account_remove_title'
  },
  bank_address: {
    defaultMessage: 'Bank Address',
    id: 'mercury.bank_address'
  },
  bank_code: {
    defaultMessage: 'Bank Code (SWIFT/BIC)',
    id: 'mercury.bank_code'
  },
  bank_code_swift: {
    defaultMessage: 'SWIFT/BIC code',
    id: 'mercury.bank_code_swift'
  },
  bank_country: {
    defaultMessage: 'Bank Country',
    id: 'mercury.bank_country'
  },
  bank_instructions: {
    defaultMessage: 'Bank Transfer Instructions',
    id: 'mercury.bank_instructions'
  },
  bank_name: {
    defaultMessage: 'Bank Name',
    id: 'mercury.bank_name'
  },
  bank_settlement_regular_generic_msg: {
    defaultMessage:
      'We encountered a potential issue with this deposit. It may be subject to further review.',
    id: 'mercury.bank_settlement_regular_generic_msg'
  },
  bank_settlement_regular_insufficient_msg: {
    defaultMessage:
      'The latest balance we fetched indicates you do not have enough funds in your bank account. You can still proceed with the deposit if you believe you have received this message in error.',
    id: 'mercury.bank_settlement_regular_insufficient_msg'
  },
  bank_settlement_regular_requires_update: {
    defaultMessage: 'Please relink your bank account to ensure faster settlement.',
    id: 'mercury.bank_settlement_regular_requires_update'
  },
  bank_settlement_regular_stale_msg: {
    defaultMessage:
      'We could not obtain an updated balance for your bank account. You can still proceed with the deposit if you believe you have sufficient funds.',
    id: 'mercury.bank_settlement_regular_stale_msg'
  },
  bank_settlement_unavailable_generic_msg: {
    defaultMessage:
      'We encountered an error while completing your deposit. Please try again. If the error persists, please contact support.',
    id: 'mercury.bank_settlement_unavailable_generic_msg'
  },
  bank_settlement_unavailable_insufficient_msg: {
    defaultMessage:
      'Your deposit failed because your linked bank account does not have sufficient funds. Please add funds and try again.',
    id: 'mercury.bank_settlement_unavailable_insufficient_msg'
  },
  bank_settlement_unavailable_requires_update: {
    defaultMessage:
      'Please relink your bank account to complete this deposit or cancel and try again with a different payment method.',
    id: 'mercury.bank_settlement_unavailable_requires_update'
  },
  bank_settlement_unavailable_stale_msg: {
    defaultMessage:
      'Your deposit failed because we could not obtain an updated balance for your bank account. Please contact your banking provider for assistance.',
    id: 'mercury.bank_settlement_unavailable_stale_msg'
  },
  bank_transfer: {
    defaultMessage: 'Bank Transfer',
    id: 'mercury.bank_transfer'
  },
  banks_and_cards: {
    defaultMessage: 'Banks & Cards',
    id: 'mercury.banks_and_cards'
  },
  blockchain_exchange: {
    defaultMessage: 'Blockchain.com Exchange',
    id: 'mercury.blockchain_exchange'
  },
  blockchain_wallet: {
    defaultMessage: 'Blockchain Wallet',
    id: 'mercury.blockchain_wallet'
  },
  button_accept: {
    defaultMessage: 'Accept',
    id: 'mercury.button_accept'
  },
  button_affiliate_program: {
    defaultMessage: 'Affiliate Program',
    id: 'mercury.button_affiliate_program'
  },
  button_cancel: {
    defaultMessage: 'Cancel',
    id: 'mercury.button_cancel'
  },
  button_cancel_all: {
    defaultMessage: 'Cancel All',
    id: 'mercury.button_cancel_all'
  },
  button_change_password: {
    defaultMessage: 'Change Password',
    id: 'mercury.button_change_password'
  },
  button_close: {
    defaultMessage: 'Close',
    id: 'mercury.button_close'
  },
  button_confirm: {
    defaultMessage: 'Confirm',
    id: 'mercury.button_confirm'
  },
  button_continue: {
    defaultMessage: 'Continue',
    id: 'mercury.button_continue'
  },
  button_continue_in_browser: {
    defaultMessage: 'Continue in browser',
    id: 'mercury.button_continue_in_browser'
  },
  button_continue_to_gold: {
    defaultMessage: 'Continue to Full Access Verification',
    id: 'mercury.button_continue_to_gold-1'
  },
  button_decline: {
    defaultMessage: 'Decline',
    id: 'mercury.button_decline'
  },
  button_deposit: {
    defaultMessage: 'Deposit',
    id: 'mercury.button_deposit'
  },
  button_deposit_blockchain_wallet: {
    defaultMessage: 'Deposit from Your Blockchain Wallet',
    id: 'mercury.button_deposit_blockchain_wallet'
  },
  button_deposit_wallet: {
    defaultMessage: 'Deposit from Your Wallet',
    id: 'mercury.button_deposit_wallet'
  },
  button_details: {
    defaultMessage: 'Details',
    id: 'mercury.button_details'
  },
  button_done: {
    defaultMessage: 'Done',
    id: 'mercury.button_done'
  },
  button_edit: {
    defaultMessage: 'Edit',
    id: 'mercury.button_edit'
  },
  button_features: {
    defaultMessage: 'Features',
    id: 'mercury.button_features'
  },
  button_fees: {
    defaultMessage: 'Fees',
    id: 'mercury.button_fees'
  },
  button_generate_new_codes: {
    defaultMessage: 'Generate new codes',
    id: 'mercury.button_generate_new_codes'
  },
  button_got_it: {
    defaultMessage: 'Got it!',
    id: 'mercury.button_got_it'
  },
  button_header_signup: {
    defaultMessage: 'Sign Up',
    id: 'mercury.button_header_signup'
  },
  button_learn_more: {
    defaultMessage: 'Learn more',
    id: 'mercury.button_learn_more'
  },
  button_load_more: {
    defaultMessage: 'Load more',
    id: 'mercury.button_load_more'
  },
  button_loading: {
    defaultMessage: 'Loading',
    id: 'mercury.button_loading'
  },
  button_need_help: {
    defaultMessage: 'Need help?',
    id: 'mercury.button_need_help'
  },
  button_next: {
    defaultMessage: 'Next',
    id: 'mercury.button_next'
  },
  button_ok: {
    defaultMessage: 'Ok',
    id: 'mercury.button_ok'
  },
  button_ok_understand: {
    defaultMessage: 'Ok, I understand',
    id: 'mercury.button_ok_understand'
  },
  button_portfolio: {
    defaultMessage: 'Portfolio',
    id: 'mercury.button_portfolio'
  },
  button_remove: {
    defaultMessage: 'Remove',
    id: 'mercury.button_remove'
  },
  button_reset_password: {
    defaultMessage: 'Reset Password',
    id: 'mercury.button_reset_password'
  },
  button_show_codes: {
    defaultMessage: 'Show Codes',
    id: 'mercury.button_show_codes'
  },
  button_signin: {
    defaultMessage: 'Login',
    id: 'mercury.button_signin'
  },
  button_signout: {
    defaultMessage: 'Log Out',
    id: 'mercury.button_signout'
  },
  button_signup: {
    defaultMessage: 'Create Account',
    id: 'mercury.button_signup'
  },
  button_support: {
    defaultMessage: 'Support',
    id: 'mercury.button_support'
  },
  button_trade: {
    defaultMessage: 'Trade',
    id: 'mercury.button_trade'
  },
  button_try_again: {
    defaultMessage: 'Try again',
    id: 'mercury.button_try_again'
  },
  button_turn_off: {
    defaultMessage: 'Turn Off',
    id: 'mercury.button_turn_off'
  },
  button_turn_on_two_factor: {
    defaultMessage: 'Add Two-Factor Now',
    id: 'mercury.button_turn_on_two_factor'
  },
  button_unlock_gold: {
    defaultMessage: 'Unlock Full Access to link a bank account',
    id: 'mercury.button_unlock_gold-1'
  },
  button_verify: {
    defaultMessage: 'Verify',
    id: 'mercury.button_verify'
  },
  button_withdraw: {
    defaultMessage: 'Withdraw',
    id: 'mercury.button_withdraw'
  },
  button_xlm_confirm: {
    defaultMessage: 'I Understand',
    id: 'mercury.button_xlm_confirm'
  },
  buy: {
    defaultMessage: 'Buy',
    id: 'mercury.buy'
  },
  cant_add_collateral: {
    defaultMessage: 'Cant add more collateral',
    id: 'mercury.cant_add_collateral'
  },
  cant_remove_collateral: {
    defaultMessage: 'Collateral is fully used to maintain the position’s risk status',
    id: 'mercury.cant_remove_collateral_1'
  },
  click_below_button: {
    defaultMessage: 'Click the button below to Deposit',
    id: 'mercury.click_below_button'
  },
  click_here_no_dot: {
    defaultMessage: 'Click here',
    id: 'mercury.click_here_no_dot'
  },
  close_position_large_amount: {
    defaultMessage: 'Amount cannot be less than {min}',
    id: 'mercury.close_position_large_amount_1'
  },
  close_position_low_amount: {
    defaultMessage: 'Amount exceeds position size',
    id: 'mercury.close_position_low_amount'
  },
  close_position_low_limit_price: {
    defaultMessage: 'Limit price for closing order must be above Margin Liquidation price',
    id: 'mercury.close_position_low_limit_price_1'
  },
  collateral: {
    defaultMessage: 'Collateral',
    id: 'mercury.collateral'
  },
  collateral_amount: {
    defaultMessage: 'Collateral Amount',
    id: 'mercury.collateral_amount'
  },
  collateral_details_tooltip: {
    defaultMessage: 'Fund balance locked up to open this position',
    id: 'mercury.collateral_details_tooltip'
  },
  collateral_edit_amount: {
    defaultMessage: 'Amount of collateral to be adjusted',
    id: 'mercury.collateral_edit_amount'
  },
  collateral_tooltip: {
    defaultMessage: 'Fund balance required to be locked up to open position',
    id: 'mercury.collateral_tooltip'
  },
  collateral_type: {
    defaultMessage: 'Collateral Type',
    id: 'mercury.collateral_type'
  },
  complete_uk_fca_questionnaire: {
    defaultMessage: 'Complete UK FCA questionnaire',
    id: 'mercury.complete_uk_fca_questionnaire'
  },
  complete_uk_fca_quiz: {
    defaultMessage: 'Complete UK FCA quiz',
    id: 'mercury.complete_uk_fca_quiz'
  },
  connected: {
    defaultMessage: 'Connected',
    id: 'mercury.connected'
  },
  contact_support: {
    defaultMessage: 'Get Help',
    id: 'mercury.contact_support'
  },
  copy_referral: {
    defaultMessage: 'Copy your referral code',
    id: 'mercury.copy_referral'
  },
  copyright: {
    defaultMessage: '© Blockchain {year} | Luxembourg S.A.',
    id: 'mercury.copyright'
  },
  created: {
    defaultMessage: 'Created',
    id: 'mercury.created'
  },
  crypto: {
    defaultMessage: 'Crypto',
    id: 'mercury.crypto'
  },
  crypto_and_fiat_deposits: {
    defaultMessage: 'Crypto and fiat deposits',
    id: 'mercury.crypto_and_fiat_deposits'
  },
  crypto_deposits: {
    defaultMessage: 'Crypto deposits',
    id: 'mercury.crypto_deposits'
  },
  current_ask: {
    defaultMessage: 'Current Ask',
    id: 'mercury.current_ask'
  },
  current_bid: {
    defaultMessage: 'Current Bid',
    id: 'mercury.current_bid'
  },
  current_fees: {
    defaultMessage: 'Your Current Fees',
    id: 'mercury.current_fees'
  },
  current_fees_desc: {
    defaultMessage:
      'Your fee tier is based upon your total USD trading volume over the trailing 30 day period. See our full rate card {link}.',
    id: 'mercury.current_fees_desc_1'
  },
  current_pair: {
    defaultMessage: 'Current pair',
    id: 'mercury.current_pair'
  },
  daily_change: {
    defaultMessage: '24h Change',
    id: 'mercury.daily_change'
  },
  daily_price: {
    defaultMessage: '24h Price',
    id: 'mercury.daily_price'
  },
  daily_volume: {
    defaultMessage: '24h Volume',
    id: 'mercury.daily_volume'
  },
  data_error: {
    defaultMessage: 'Server Error {cause}',
    id: 'mercury.data_error'
  },
  delete: {
    defaultMessage: 'Delete',
    id: 'mercury.delete'
  },
  delete_whitelist: {
    defaultMessage: 'Delete Whitelist',
    id: 'mercury.delete_whitelist'
  },
  deposit: {
    defaultMessage: 'Deposit',
    id: 'mercury.deposit'
  },
  deposit_advice: {
    defaultMessage: 'Please send only {value} to this address.',
    id: 'mercury.deposit_advice'
  },
  deposit_advice_dot_min: {
    defaultMessage: 'Minimum deposit amount is 1.15 {currency}.',
    id: 'mercury.deposit_advice_dot_min1'
  },
  deposit_advice_erc20_tokens: {
    defaultMessage:
      '{currency} is only supported on the Ethereum network.\nDO NOT send {currency} in any other network as your assets will be lost. Processing times may vary.',
    id: 'mercury.deposit_advice_erc20_tokens1'
  },
  deposit_clout_memo_content: {
    defaultMessage:
      'Please send only {currency} tokens to this address. Verify you are sending {currency} tokens and not "Creators coins", otherwise your money will be lost. Processing times vary.',
    id: 'mercury.deposit_clout_memo_content1'
  },
  deposit_currency: {
    defaultMessage: 'Deposit {currency}',
    id: 'mercury.deposit_currency'
  },
  deposit_history: {
    defaultMessage: 'Deposit History',
    id: 'mercury.deposit_history'
  },
  deposit_modulr_terms_part_1_a: {
    defaultMessage: 'The recipient name',
    id: 'mercury.deposit_modulr_terms_part_1_a'
  },
  deposit_modulr_terms_part_1_b: {
    defaultMessage: 'must match',
    id: 'mercury.deposit_modulr_terms_part_1_b'
  },
  deposit_modulr_terms_part_1_c: {
    defaultMessage:
      'the account holder’s name on your bank account for your transfer to be successful. Your transfer could be rejected if there is not a match. By depositing funds to this account, you agree to',
    id: 'mercury.deposit_modulr_terms_part_1_c'
  },
  deposit_modulr_terms_part_2: {
    defaultMessage: 'of Modulr, our banking partner.',
    id: 'mercury.deposit_modulr_terms_part_2'
  },
  deposit_name_match_viban: {
    defaultMessage:
      'Your recipient name above must match the account holder’s name on your bank account for your transfer to be successful. Your transfer could be rejected if there is not a match.',
    id: 'mercury.deposit_name_match_eur'
  },
  deposit_name_match_wire_1: {
    defaultMessage:
      'Make sure to double-check that the name on your bank account matches your Exchange Account:',
    id: 'mercury.deposit_name_match_usd_1-3'
  },
  deposit_name_match_wire_2: {
    defaultMessage: '. If not, your deposit could be delayed or rejected.',
    id: 'mercury.deposit_name_match_usd_2-2'
  },
  deposit_non_usa_bank: {
    defaultMessage: 'From Non-USA Banks',
    id: 'mercury.deposit_non_usa_bank'
  },
  deposit_now: {
    defaultMessage: 'Deposit now',
    id: 'mercury.deposit_now'
  },
  deposit_pending_description_ob_1: {
    defaultMessage:
      "A deposit of {amount}, has been started. Order is being processed, we will let you know once it's done. You can safely close this modal while we update the order in the background.",
    id: 'mercury.deposit_pending_description_ob_1'
  },
  deposit_pending_title: {
    defaultMessage: 'Deposit Pending',
    id: 'mercury.deposit_pending'
  },
  deposit_processing_times: {
    defaultMessage: 'Processing times vary.',
    id: 'mercury.deposit_processing_times'
  },
  deposit_stablecoins: {
    defaultMessage: 'Deposit Stablecoins',
    id: 'mercury.deposit_stablecoins'
  },
  deposit_time: {
    defaultMessage: 'Deposit time',
    id: 'mercury.deposit_time'
  },
  deposit_to_trade: {
    defaultMessage: 'Deposit to Trade',
    id: 'mercury.deposit_to_trade'
  },
  deposit_usa_bank: {
    defaultMessage: 'From USA Banks',
    id: 'mercury.deposit_usa_bank'
  },
  deposit_verify_account_disclaimer_4: {
    defaultMessage:
      'We currently do not accept ACH deposits from Silvergate Bank. Please do not attempt an ACH deposit at this time.',
    id: 'mercury.deposit_verify_account_disclaimer_4'
  },
  deposit_verify_account_disclaimer_5: {
    defaultMessage:
      'Securely deposit US dollars to your Exchange Account from your bank via wire transfer. Do this through online banking, a mobile banking app, or by contacting your bank directly.',
    id: 'mercury.deposit_verify_account_disclaimer_5'
  },
  deposit_verify_upt_account_disclaimer_p1: {
    defaultMessage:
      'Securely deposit money to your Exchange account and start trading within 30 minutes when you transfer Turkish Lira directly from your bank.',
    id: 'mercury.deposit_verify_upt_account_disclaimer_p1'
  },
  deposit_verify_upt_account_disclaimer_p2: {
    defaultMessage:
      'Please note: Bank transfers sent outside of banking hours will be processed the next day.',
    id: 'mercury.deposit_verify_upt_account_disclaimer_p2'
  },
  deposit_via_bank: {
    defaultMessage: 'Deposit via Bank',
    id: 'mercury.deposit_via_bank'
  },
  deposit_what_is_memo: {
    defaultMessage: 'What is a Memo?',
    id: 'mercury.deposit_what_is_memo'
  },
  deposit_what_is_tag: {
    defaultMessage: 'What is a Tag?',
    id: 'mercury.deposit_what_is_tag'
  },
  deposit_xlm_memo: {
    defaultMessage: '{currency} Memo Required',
    id: 'mercury.deposit_xlm_memo1'
  },
  deposit_xlm_memo_content: {
    defaultMessage:
      'If you send funds without the {currency} Memo Text, your funds will be lost and not credited to your account. Please send only {currency} to this address.',
    id: 'mercury.deposit_xlm_memo_content1'
  },
  deposit_xrp_tag: {
    defaultMessage: '{currency} Tag Required',
    id: 'mercury.deposit_xrp_tag1'
  },
  deposit_xrp_tag_content: {
    defaultMessage:
      'If you send funds without the {currency} Tag Text, your funds will be lost and not credited to your account. Please send only {currency} to this address.',
    id: 'mercury.deposit_xrp_tag_content1'
  },
  deposits: {
    defaultMessage: 'Deposits',
    id: 'mercury.deposits'
  },
  description_2FA_is_required: {
    defaultMessage: '2FA is required for withdrawals.',
    id: 'mercury.description_2FA_is_required'
  },
  description_api_settings: {
    defaultMessage:
      'Access the Exchange API. Trade on our continuous first-come, first-serve order book. Orders are executed in price-time priority as received by our Matching Engine.',
    id: 'mercury.description_api_settings-1'
  },
  description_api_settings_note: {
    defaultMessage:
      'Note: API keys should only be used by advanced user. Before creating your API keys please read our',
    id: 'mercury.description_api_settings_note'
  },
  description_api_settings_note_link: {
    defaultMessage: 'API Docs.',
    id: 'mercury.description_api_settings_note-link'
  },
  description_authenticator: {
    defaultMessage:
      'A mobile app, like Google Authenticator that generates a dynamic 6-8 digit one-time password.',
    id: 'mercury.description_authenticator'
  },
  description_backup_2fa: {
    defaultMessage: 'Make sure to write these down.',
    id: 'mercury.description_backup_2fa'
  },
  description_backup_2fa_print: {
    defaultMessage: 'Tap to print',
    id: 'mercury.description_backup_2fa_print'
  },
  description_linked_accounts: {
    defaultMessage:
      'Deposit and Withdraw cash with ease. You will need at least 1 linked bank to make any deposit or withdrawal.',
    id: 'mercury.description_linked_accounts'
  },
  description_setup_2fa_app: {
    defaultMessage: 'Open Authenticator App',
    id: 'mercury.description_setup_2fa_app'
  },
  description_setup_2fa_qr: {
    defaultMessage: 'Scan the QR code to add a new token',
    id: 'mercury.description_setup_2fa_qr'
  },
  description_updated_bitcoin_special: {
    defaultMessage:
      'For the month of December, all Maker Taker Fees are 50% OFF. Offers end on {date}. Trade away!',
    id: 'mercury.description_updated_bitcoin_special'
  },
  description_veriff: {
    defaultMessage: 'Verify Your Identity',
    id: 'mercury.description_veriff'
  },
  description_veriff_extra: {
    defaultMessage:
      'We ask for a live photo of you, your official identity document and one of you holding the document.',
    id: 'mercury.description_veriff_extra'
  },
  download: {
    defaultMessage: 'Download',
    id: 'mercury.download'
  },
  email_code: {
    defaultMessage: 'Email code',
    id: 'mercury.email_code'
  },
  empty_orders_1: {
    defaultMessage: "Don't see your order? Try Download",
    id: 'mercury.empty_orders_1'
  },
  empty_payments: {
    defaultMessage: 'Nothing here!',
    id: 'mercury.empty_payments'
  },
  empty_positions: {
    defaultMessage: 'No Positions',
    id: 'mercury.empty_positions'
  },
  empty_simple_trade_orders: {
    defaultMessage: 'No Simple Trade Orders',
    id: 'mercury.empty_simple_trade_orders'
  },
  empty_trades: {
    defaultMessage: 'No trade data is available',
    id: 'mercury.empty_trades'
  },
  enter_amount: {
    defaultMessage: 'Enter Amount',
    id: 'mercury.enter_amount'
  },
  entry_price: {
    defaultMessage: 'Entry Price',
    id: 'mercury.entry_price'
  },
  error_contact_support: {
    defaultMessage: 'If this keeps happening contact {value}.',
    id: 'mercury.error_contact_support'
  },
  estimated_liquidation_price: {
    defaultMessage: 'Est. Liquidation Price',
    id: 'mercury.estimated_liquidation_price'
  },
  exceeds_remove_collateral: {
    defaultMessage: 'amount exceeds your removable collateral to maintain a safe position',
    id: 'mercury.exceeds_remove_collateral'
  },
  exchange_rate: {
    defaultMessage: 'Exchange Rate',
    id: 'mercury.exchange_rate'
  },
  fee_percentage_maker: {
    defaultMessage: 'Maker {value}%',
    id: 'mercury.fee_percentage_maker'
  },
  fee_percentage_margin_interest: {
    defaultMessage: 'Margin recurring fees is {rate} every {time}',
    id: 'mercury.fee_percentage_margin_interest_3'
  },
  fee_percentage_taker: {
    defaultMessage: 'Taker {value}%',
    id: 'mercury.fee_percentage_taker'
  },
  fees: {
    defaultMessage: 'Fees',
    id: 'mercury.fees'
  },
  fees_accrued: {
    defaultMessage: 'Fees Accrued',
    id: 'mercury.fees_accrued'
  },
  fees_description: {
    defaultMessage:
      'Your fee tier is based upon total USD trading volume over the trailing 30 day period. See',
    id: 'mercury.fees_description'
  },
  fees_description_link: {
    defaultMessage: 'full fee rate card',
    id: 'mercury.fees_description_link'
  },
  fees_duration: {
    defaultMessage: 'Past 30 Days',
    id: 'mercury.fees_duration'
  },
  fiat: {
    defaultMessage: 'Fiat',
    id: 'mercury.fiat'
  },
  field_exceeds_balance: {
    defaultMessage: '{field} exceeds your max {balance} balance',
    id: 'mercury.field_exceeds_balance'
  },
  fill_price: {
    defaultMessage: 'Fill Price',
    id: 'mercury.filled_price'
  },
  filled: {
    defaultMessage: 'Filled',
    id: 'mercury.filled'
  },
  filled_remaining: {
    defaultMessage: 'Filled (Remaining)',
    id: 'mercury.filled_remaining'
  },
  free: {
    defaultMessage: 'Free',
    id: 'mercury.free'
  },
  gbp_promo_alert_description: {
    defaultMessage:
      'Trade all GBP and EUR pairs with the lowest fees (0.00% Maker / 0.06% Taker) through the end of October 2022',
    id: 'mercury.gbp_promo_alert_description1'
  },
  gbp_promo_alert_title: {
    defaultMessage: 'Trade GBP and EUR pairs with lowest fees',
    id: 'mercury.gbp_promo_alert_title1'
  },
  general_alert_1: {
    defaultMessage: 'The Exchange is currently down for maintenance.',
    id: 'mercury.general_alert_1'
  },
  general_alert_2: {
    defaultMessage: "Don't worry, your funds are safe. Access will resume shortly.",
    id: 'mercury.general_alert_2'
  },
  generic_data_error: {
    defaultMessage: 'Oops! Something went wrong.',
    id: 'mercury.generic_data_error'
  },
  go_back: {
    defaultMessage: 'Go Back',
    id: 'mercury.go_back'
  },
  go_to_wallet: {
    defaultMessage: 'Go to Wallet',
    id: 'mercury.go_to_wallet'
  },
  gold: {
    defaultMessage: 'Full Access',
    id: 'mercury.gold-1'
  },
  gold_unavailable_info_subtitle: {
    defaultMessage:
      'We’re sorry we can’t verify you for Full Access. This can be for a number of reasons, for example your country might not be supported right now. If you’re Limited Access verified you can trade your crypto.',
    id: 'mercury.gold_unavailable_info_subtitle-1'
  },
  gold_unavailable_title: {
    defaultMessage: 'Full Access Unavailable at This Time',
    id: 'mercury.gold_unavailable_title-1'
  },
  gold_verification: {
    defaultMessage: 'Full Access Verification',
    id: 'mercury.gold_verification-1'
  },
  good_to: {
    defaultMessage: 'Good To',
    id: 'mercury.good_to'
  },
  gov_issued_id: {
    defaultMessage: 'Government Issued ID',
    id: 'mercury.gov_issued_id'
  },
  header_actions: {
    defaultMessage: 'Actions',
    id: 'mercury.header_actions'
  },
  header_amount: {
    defaultMessage: 'Amount',
    id: 'mercury.header_amount'
  },
  header_asset: {
    defaultMessage: 'Asset',
    id: 'mercury.header_asset'
  },
  header_available_balance: {
    defaultMessage: 'Available Balance',
    id: 'mercury.header_available_balance'
  },
  header_confirmations: {
    defaultMessage: 'Confirmations',
    id: 'mercury.confirmations'
  },
  header_currency: {
    defaultMessage: 'Currency',
    id: 'mercury.header_currency'
  },
  header_date_time: {
    defaultMessage: 'Date/Time',
    id: 'mercury.header_date_time'
  },
  header_fee: {
    defaultMessage: 'Fee',
    id: 'mercury.header_fee'
  },
  header_fiat_value: {
    defaultMessage: '{fiat} Value',
    id: 'mercury.header_fiat_value'
  },
  header_message: {
    defaultMessage: 'Message',
    id: 'mercury.header_message'
  },
  header_open_orders: {
    defaultMessage: 'Open Orders',
    id: 'mercury.header_open_orders'
  },
  header_order_id: {
    defaultMessage: 'Order ID',
    id: 'mercury.header_order_id'
  },
  header_percent_portfolio: {
    defaultMessage: '% Portfolio',
    id: 'mercury.header_percent_portfolio'
  },
  header_side: {
    defaultMessage: 'Side',
    id: 'mercury.header_side'
  },
  header_status: {
    defaultMessage: 'Status',
    id: 'mercury.header_status'
  },
  header_symbol: {
    defaultMessage: 'Symbol',
    id: 'mercury.header_symbol'
  },
  header_total_balance: {
    defaultMessage: 'Total Balance',
    id: 'mercury.header_total_balance'
  },
  header_transaction_hash: {
    defaultMessage: 'Transaction Hash / Payment Id',
    id: 'mercury.header_transaction_hash_1'
  },
  header_type: {
    defaultMessage: 'Type',
    id: 'mercury.header_type'
  },
  here: {
    defaultMessage: 'here',
    id: 'mercury.here'
  },
  higher_limits: {
    defaultMessage: 'Higher Limits',
    id: 'mercury.higher_limits'
  },
  history: {
    defaultMessage: 'History',
    id: 'mercury.history'
  },
  important: {
    defaultMessage: 'Important',
    id: 'mercury.important'
  },
  in_manual_review: {
    defaultMessage: 'In Manual Review',
    id: 'mercury.in_manual_review'
  },
  include_reference_id_label: {
    defaultMessage: 'Reference ID',
    id: 'mercury.include_reference_id_label'
  },
  include_reference_id_text_p2_1: {
    defaultMessage: 'listed above.',
    id: 'mercury.include_reference_id_text_p2_1'
  },
  include_reference_id_text_p2_2: {
    defaultMessage: 'Only send funds from a bank account in your name',
    id: 'mercury.include_reference_id_text_p4'
  },
  include_reference_id_text_p3: {
    defaultMessage: 'If not, your deposit could be delayed or rejected.',
    id: 'mercury.include_reference_id_text_p3'
  },
  increase_trading_limits: {
    defaultMessage: 'Increase the amount you can trade in the Exchange',
    id: 'mercury.increase_trading_limits-1'
  },
  info: {
    defaultMessage: 'Level',
    id: 'mercury.info'
  },
  interstitial_modal_description: {
    defaultMessage:
      'We are improving our login experience so users will get the same login on the Blockchain.com Wallet and Exchange. To log in to either, you’ll go to {url} to enter your details.',
    id: 'mercury.interstitial_modal_description'
  },
  interstitial_modal_title: {
    defaultMessage: 'Log In Has Been Improved',
    id: 'mercury.interstitial_modal_title'
  },
  invalid_code: {
    defaultMessage: 'Invalid code',
    id: 'mercury.invalid_code'
  },
  invalid_email_error: {
    defaultMessage: 'Please enter a valid email',
    id: 'mercury.invalid_email_error'
  },
  invalid_mobile_phone_number: {
    defaultMessage: 'Invalid mobile phone number',
    id: 'mercury.invalid_mobile_phone_number'
  },
  ios: {
    defaultMessage: 'iOS',
    id: 'mercury.ios'
  },
  ko_change_password: {
    defaultMessage: 'Incorrect password.',
    id: 'mercury.ko_change_password'
  },
  ko_deposits: {
    defaultMessage: 'Failed to load deposits.',
    id: 'mercury.ko_deposits'
  },
  ko_generic: {
    defaultMessage: 'Error.',
    id: 'mercury.ko_generic'
  },
  ko_order_cancelled: {
    defaultMessage: 'Order cancelled',
    id: 'mercury.ko_order_cancelled'
  },
  ko_order_expired: {
    defaultMessage: 'Order expired',
    id: 'mercury.ko_order_expired'
  },
  ko_payments_remove_beneficiaries: {
    defaultMessage: 'Failed to remove linked account.',
    id: 'mercury.ko_payments_remove_beneficiaries'
  },
  ko_payments_remove_whitelist: {
    defaultMessage: 'Failed to remove whitelisted address.',
    id: 'mercury.ko_payments_remove_whitelist'
  },
  ko_signup: {
    defaultMessage: 'Registration failed.',
    id: 'mercury.ko_signup'
  },
  ko_tier_two: {
    defaultMessage: 'Upgrading your account failed.',
    id: 'mercury.ko_tier_two'
  },
  ko_two_factor: {
    defaultMessage: 'Incorrect Two Factor',
    id: 'mercury.ko_two_factor'
  },
  ko_user_not_found: {
    defaultMessage: 'User not found.',
    id: 'mercury.ko_user_not_found'
  },
  ko_verify_totp: {
    defaultMessage: 'Wrong code, please try again',
    id: 'mercury.ko_verify_totp'
  },
  ko_withdrawals: {
    defaultMessage: 'Failed to load withdrawals.',
    id: 'mercury.ko_withdrawals'
  },
  kyc_resubmission_cta: {
    defaultMessage: 'Re-verify Now',
    id: 'mercury.kyc_resubmission_cta'
  },
  kyc_resubmission_description: {
    defaultMessage:
      'Please re-verify your identity to complete account reset. Some features may not be available until you do.',
    id: 'mercury.kyc_resubmission_description'
  },
  kyc_resubmission_title: {
    defaultMessage: 'Documents Needed',
    id: 'mercury.kyc_resubmission_title'
  },
  kyc_under_review: {
    defaultMessage: 'Your application is under further review',
    id: 'mercury.kyc_under_review'
  },
  kyc_verified: {
    defaultMessage: 'You have been verified!',
    id: 'mercury.kyc_verified'
  },
  label_amount: {
    defaultMessage: 'Amount',
    id: 'mercury.label_amount'
  },
  label_city: {
    defaultMessage: 'Town/City',
    id: 'mercury.label_city'
  },
  label_code: {
    defaultMessage: 'Verification code',
    id: 'mercury.label_code'
  },
  label_code_sent_to: {
    defaultMessage: 'Code sent to - {email}',
    id: 'mercury.label_code_sent_to'
  },
  label_confirm_deposit: {
    defaultMessage: 'Confirm Deposit',
    id: 'mercury.label_confirm_deposit'
  },
  label_confirm_new_password: {
    defaultMessage: 'Confirm new password',
    id: 'mercury.label_confirm_new_password'
  },
  label_confirm_password: {
    defaultMessage: 'Confirm Password',
    id: 'mercury.label_confirm_password'
  },
  label_country: {
    defaultMessage: 'Country',
    id: 'mercury.label_country'
  },
  label_currency: {
    defaultMessage: 'Currency',
    id: 'mercury.label_currency'
  },
  label_day: {
    defaultMessage: '{value} Day',
    id: 'mercury.label_day'
  },
  label_decimal: {
    defaultMessage: '{value} Decimals',
    id: 'mercury.label_decimal'
  },
  label_deposit_failed: {
    defaultMessage: 'Deposit Failed',
    id: 'mercury.label_deposit_failed'
  },
  label_deposit_pending: {
    defaultMessage: 'Deposit in Progress',
    id: 'mercury.label_deposit_pending'
  },
  label_deposit_wire: {
    defaultMessage: 'Reference ID (Mandatory)',
    id: 'mercury.label_deposit_wire_1'
  },
  label_dob: {
    defaultMessage: 'Date of Birth',
    id: 'mercury.label_dob'
  },
  label_edd_funds: {
    defaultMessage: 'What is your source of funds?',
    id: 'mercury.label_edd_funds'
  },
  label_edd_intention_1: {
    defaultMessage: 'Buying cryptocurrencies using your fiat currency (£/€/$)',
    id: 'mercury.label_edd_intention_1'
  },
  label_edd_intention_2: {
    defaultMessage: 'Placing occasional speculative trades, on average 1-2 trades a month',
    id: 'mercury.label_edd_intention_2'
  },
  label_edd_intention_3: {
    defaultMessage: 'Semi-frequent trading, placing multiple trades a month',
    id: 'mercury.label_edd_intention_3'
  },
  label_edd_intention_4: {
    defaultMessage: 'High frequency trading, placing many trades a day',
    id: 'mercury.label_edd_intention_4'
  },
  label_edd_intentions_sub: {
    defaultMessage: 'Please check all that apply.',
    id: 'mercury.label_edd_intentions_sub'
  },
  label_edd_intentions_title: {
    defaultMessage: 'What are you using Blockchain.com Exchange for?',
    id: 'mercury.label_edd_intentions_title'
  },
  label_edd_volume: {
    defaultMessage: 'What is your expected average monthly trading volume?',
    id: 'mercury.label_edd_volume'
  },
  label_email: {
    defaultMessage: 'Email',
    id: 'mercury.label_email'
  },
  label_first_line: {
    defaultMessage: 'Street Address',
    id: 'mercury.label_first_line'
  },
  label_first_line_us: {
    defaultMessage: 'Address',
    id: 'mercury.label_first_line_us'
  },
  label_firstname: {
    defaultMessage: 'First Name',
    id: 'mercury.label_firstname'
  },
  label_full: {
    defaultMessage: 'Get Balances & Make Trades & Withdrawals',
    id: 'mercury.label_full'
  },
  label_ip_whitelist: {
    defaultMessage: 'IP Whitelist',
    id: 'mercury.label_ip_whitelist'
  },
  label_lastname: {
    defaultMessage: 'Last Name',
    id: 'mercury.label_lastname'
  },
  label_liquidity: {
    defaultMessage: 'Post Only',
    id: 'mercury.label_liquidity'
  },
  label_local_currency: {
    defaultMessage: 'Local Currency',
    id: 'mercury.label_local_currency'
  },
  label_manage_2fa: {
    defaultMessage: 'Manage 2FA',
    id: 'mercury.label_manage_2fa'
  },
  label_memo: {
    defaultMessage: '{value} Memo',
    id: 'mercury.label_memo'
  },
  label_minimum_amount: {
    defaultMessage: 'Minimum Amount',
    id: 'mercury.label_minimum_amount'
  },
  label_month: {
    defaultMessage: '{value} Month',
    id: 'mercury.label_month'
  },
  label_months: {
    defaultMessage: '{value} Months',
    id: 'mercury.label_months'
  },
  label_name: {
    defaultMessage: 'Name',
    id: 'mercury.label_name'
  },
  label_old_password: {
    defaultMessage: 'Old password',
    id: 'mercury.label_old_password'
  },
  label_password: {
    defaultMessage: 'Password',
    id: 'mercury.label_password'
  },
  label_password_new: {
    defaultMessage: 'Choose a new password',
    id: 'mercury.label_password_new'
  },
  label_permissions: {
    defaultMessage: 'Permissions',
    id: 'mercury.label_permissions'
  },
  label_postcode: {
    defaultMessage: 'Postcode',
    id: 'mercury.label_postcode'
  },
  label_price: {
    defaultMessage: 'Limit Price',
    id: 'mercury.label_price'
  },
  label_read: {
    defaultMessage: 'Get Balances',
    id: 'mercury.label_read'
  },
  label_show_notifications: {
    defaultMessage: 'Show Notifications',
    id: 'mercury.label_show_notifications'
  },
  label_ssn: {
    defaultMessage: 'SSN or Individual Tax I.D. #',
    id: 'mercury.label_ssn'
  },
  label_state: {
    defaultMessage: 'State/County',
    id: 'mercury.label_state'
  },
  label_tag: {
    defaultMessage: '{value} Tag',
    id: 'mercury.label_tag'
  },
  label_ticket_field_percetage_max: {
    defaultMessage: 'Max',
    id: 'mercury.label_ticket_field_percetage_max'
  },
  label_trigger_price: {
    defaultMessage: 'Trigger Price',
    id: 'mercury.label_trigger_price'
  },
  label_two_fa_withdrawal_six_digit_code_placeholder: {
    defaultMessage: '6 Digit Code',
    id: 'mercury.label_two_fa_withdrawal_six_digit_code_placeholder'
  },
  label_two_fa_withdrawal_sms_code: {
    defaultMessage: 'SMS Code',
    id: 'mercury.label_two_fa_withdrawal_sms_code'
  },
  label_two_fa_withdrawal_sms_code_placeholder: {
    defaultMessage: 'Enter SMS Code',
    id: 'mercury.label_two_fa_withdrawal_sms_code_placeholder'
  },
  label_two_fa_withdrawal_two_step_code: {
    defaultMessage: 'Enter the 2-step verification code',
    id: 'mercury.label_two_fa_withdrawal_two_step_code'
  },
  label_two_fa_withdrawal_yubikey_placeholder: {
    defaultMessage: 'Tap Yubikey to enter code',
    id: 'mercury.label_two_fa_withdrawal_yubikey_placeholder'
  },
  label_verif_code: {
    defaultMessage: 'Enter your Google Authenticator code here',
    id: 'mercury.label_verif_code'
  },
  label_wallet_address: {
    defaultMessage: '{value} Wallet Address',
    id: 'mercury.label_wallet_address'
  },
  label_week: {
    defaultMessage: '{value} Week',
    id: 'mercury.label_week'
  },
  label_withdrawal_address: {
    defaultMessage: 'Destination {value} Address',
    id: 'mercury.label_withdrawal_address'
  },
  label_write: {
    defaultMessage: 'Get Balances & Make Trades',
    id: 'mercury.label_write'
  },
  label_zipcode: {
    defaultMessage: 'Zipcode',
    id: 'mercury.label_zipcode'
  },
  last_24_hrs: {
    defaultMessage: 'last 24hrs',
    id: 'mercury.last_24_hrs'
  },
  last_price: {
    defaultMessage: 'Last Price',
    id: 'mercury.last_price'
  },
  last_trade: {
    defaultMessage: 'Last Trade',
    id: 'mercury.last_trade'
  },
  last_traded_price_of: {
    defaultMessage: 'last traded price of',
    id: 'mercury.last_traded_price_of'
  },
  learn_more: {
    defaultMessage: 'Learn more',
    id: 'mercury.learn_more'
  },
  learn_more_about_verification: {
    defaultMessage: 'If you want to learn more about our verification process. Visit our',
    id: 'mercury.learn_more_about_verification'
  },
  legal: {
    defaultMessage: 'Legal',
    id: 'mercury.legal'
  },
  leverage_ratio_tooltip: {
    defaultMessage: 'Multiple applied to your collateral to open position',
    id: 'mercury.leverage_ratio_tooltip'
  },
  limit: {
    defaultMessage: 'Limit',
    id: 'mercury.limit'
  },
  limit_price: {
    defaultMessage: 'Limit Price',
    id: 'mercury.limit_price'
  },
  limits_and_fees: {
    defaultMessage: 'Limits & Fees',
    id: 'mercury.limits_and_fees'
  },
  limits_disclaimer: {
    defaultMessage:
      'Transaction limits may apply to certain banks and card issuers. Purchase or deposit limits are determined by many factors, including verification completed on your account, your purchase history, your payment type, and more. Extra checks may apply for amounts over $100,000.00.',
    id: 'mercury.limit_disclaimer'
  },
  limits_gold: {
    defaultMessage: 'Full Access Limits',
    id: 'mercury.limits_gold-1'
  },
  limits_gold_desc: {
    defaultMessage: 'Pro Level Trading Limits & Features',
    id: 'mercury.limits_gold_desc'
  },
  limits_silver: {
    defaultMessage: 'Limited Access Limits',
    id: 'mercury.limits_silver-1'
  },
  limits_silver_desc: {
    defaultMessage: 'Basic Exchange Trading',
    id: 'mercury.limits_silver_desc'
  },
  link_bank_account_description: {
    defaultMessage:
      'In order to withdraw {currency}, you need to first make a small deposit so that we can link your bank account.',
    id: 'mercury.link_bank_account_description'
  },
  link_bank_agreement_access_expire: {
    defaultMessage:
      '{entity} will then use these details with Blockchain solely for the purposes of buying cryptocurrencies. This access is valid until {date}, you can cancel consent at any time via the Blockchain settings or via your bank. This request is not a one-off, you will continue to receive consent requests as older versions expire.',
    id: 'mercury.link_bank_agreement_access_expire'
  },
  link_bank_agreement_access_noexpire: {
    defaultMessage:
      '{entity} will then use these details with Blockchain.com solely for the purposes of buying cryptocurrencies. This consent request is a one-off, you will not receive additional requests once completed.',
    id: 'mercury.link_bank_agreement_access_noexpire'
  },
  link_bank_agreement_data_sharing: {
    defaultMessage:
      '{entity} will retrieve your bank data based on your request and provide this information to Blockchain.',
    id: 'mercury.link_bank_agreement_data_sharing'
  },
  link_bank_agreement_fca_auth_1: {
    defaultMessage:
      'Blockchain is an agent of {entity}. {entity} is authorised and regulated by the Financial Conduct Authority under the Payment Service Regulations 2017 [827001] for the provision of Account Information and Payment Initiation services.',
    id: 'mercury.link_bank_agreement_fca_auth_1'
  },
  link_bank_agreement_fca_auth_2: {
    defaultMessage:
      'In order to share your Deutsche Bank data with Blockchain, you will now be securely redirected to your bank to confirm your consent for {entity} to read the following information:',
    id: 'mercury.link_bank_agreement_fca_auth_2'
  },
  link_bank_agreement_fca_auth_acc_details: {
    defaultMessage: 'Account(s) details',
    id: 'mercury.link_bank_agreement_fca_auth_acc_details'
  },
  link_bank_agreement_fca_auth_id_details: {
    defaultMessage: 'Identification details',
    id: 'mercury.link_bank_agreement_fca_auth_id_details'
  },
  link_bank_agreement_secure_connection: {
    defaultMessage:
      'Data is securely retrieved in read-only format and only for the duration agreed with you. You have the right to withdraw your consent at any time.',
    id: 'mercury.link_bank_agreement_secure_connection'
  },
  link_bank_connect_bank_desktop: {
    defaultMessage: 'Link via desktop',
    id: 'mercury.link_bank_connect_bank_desktop'
  },
  link_bank_connect_bank_loading: {
    defaultMessage: 'Waiting to hear from your bank',
    id: 'mercury.link_bank_connect_bank_loading'
  },
  link_bank_connect_bank_qr_subtitle: {
    defaultMessage: 'Use your phone’s camera to scan the QR code.',
    id: 'mercury.link_bank_connect_bank_desktop_subtitle'
  },
  link_bank_connect_bank_qr_title: {
    defaultMessage: 'Link via mobile',
    id: 'mercury.link_bank_connect_bank_qr_title'
  },
  link_bank_connect_bank_title: {
    defaultMessage: 'Connect your bank',
    id: 'mercury.link_bank_connect_bank_title'
  },
  link_bank_description: {
    defaultMessage: 'Securley link your bank and deposit {currency} into your Exchange account.',
    id: 'mercury.link_bank_description'
  },
  link_bank_error_account_already_linked: {
    defaultMessage: 'Already Linked Bank',
    id: 'mercury.link_bank_error_account_already_linked'
  },
  link_bank_error_account_expired: {
    defaultMessage: 'Expired Account Access',
    id: 'mercury.link_bank_error_account_expired'
  },
  link_bank_error_bank_transfer_payment_insufficient_funds_desc: {
    defaultMessage:
      'This payment method does not have enough funds to complete the deposit. Please update your payment details and try again.',
    id: 'mercury.link_bank_error_bank_transfer_payment_insufficient_funds_desc'
  },
  link_bank_error_bank_transfer_payment_invalid_desc: {
    defaultMessage:
      'The payment account you deposited from is no longer active. Please update your payment details and try again.',
    id: 'mercury.link_bank_error_bank_transfer_payment_invalid_desc'
  },
  link_bank_error_bank_transfer_payment_limited_exceeded_desc: {
    defaultMessage:
      'Your account currently has multiple transfers in progress. Please wait for those transfers to complete and then try again.',
    id: 'mercury.link_bank_error_bank_transfer_payment_limited_exceeded_desc'
  },
  link_bank_error_bank_transfer_payment_rejected_desc: {
    defaultMessage:
      'You deposit was unsuccessful. Please confirm your payment details and try again.',
    id: 'mercury.link_bank_error_bank_transfer_payment_rejected_desc'
  },
  link_bank_error_failed_title: {
    defaultMessage: 'Failed Connection Request',
    id: 'mercury.link_bank_error_failed_title'
  },
  link_bank_error_invalid_subtitle: {
    defaultMessage:
      'Your bank may charge you extra fees if you buy crypto without a checking account.',
    id: 'mercury.link_bank_error_invalid_subtitle_v2'
  },
  link_bank_error_invalid_title: {
    defaultMessage: 'Please link a Checking Account.',
    id: 'mercury.link_bank_error_invalid_title'
  },
  link_bank_error_manual_review_desc: {
    defaultMessage:
      'Your deposit is being processed but is taking longer than expected. Please check the status of your payment later.',
    id: 'mercury.link_bank_error_manual_review_desc'
  },
  link_bank_error_name_subtitle: {
    defaultMessage:
      'We noticed the names don’t match. The bank you link must have a matching legal first & last name as your Blockchain.com Account. {link}',
    id: 'mercury.link_bank_error_name_subtitle'
  },
  link_bank_error_name_title: {
    defaultMessage: 'Is this your bank?',
    id: 'mercury.link_bank_error_name_title'
  },
  link_bank_error_payment_declined: {
    defaultMessage: 'Payment canceled or declined by institution.',
    id: 'mercury.link_bank_error_payment_declined'
  },
  link_bank_error_rejected_subtitle: {
    defaultMessage:
      'Please try linking your bank again and approve the connection. If this keeps happening, please {link}.',
    id: 'mercury.link_bank_error_rejected_subtitle'
  },
  link_bank_error_rejected_title: {
    defaultMessage: 'Connection Rejected',
    id: 'mercury.link_bank_error_rejected_title'
  },
  link_bank_error_timeout_desc: {
    defaultMessage:
      'Your deposit is being processed but is taking longer than expected. Please check the status of your payment later.',
    id: 'mercury.link_bank_error_timeout_desc'
  },
  link_bank_pending_subtitle: {
    defaultMessage: 'This could take up to 30 seconds. Please do not go back or close the app.',
    id: 'mercury.link_bank_pending_subtitle'
  },
  link_bank_pending_title: {
    defaultMessage: 'Updating Your Account...',
    id: 'mercury.link_bank_pending_title'
  },
  link_bank_select_bank_title: {
    defaultMessage: 'Find your bank',
    id: 'mercury.link_bank_select_bank_title'
  },
  link_bank_success_subtitle: {
    defaultMessage: 'Your {name} account is now linked to your Blockchain.com Exchange...',
    id: 'mercury.link_bank_success_subtitle'
  },
  link_bank_success_title: {
    defaultMessage: 'Bank Linked!',
    id: 'mercury.link_bank_success_title'
  },
  link_bank_try_again: {
    defaultMessage: 'Please try linking your bank again. If this keeps happening, please {link}',
    id: 'mercury.link_bank_try_again'
  },
  linked_accounts_subtitle1: {
    defaultMessage: 'Your Linked Accounts',
    id: 'mercury.linked_accounts_subtitle1'
  },
  linked_banks: {
    defaultMessage: 'Linked Banks',
    id: 'mercury.linked_banked'
  },
  linked_banks_details: {
    defaultMessage:
      'Connect your bank account to deposit cash, trade for crypto and withdraw back to.',
    id: 'mercury.linked_banks_details_v2'
  },
  loading_data: {
    defaultMessage: 'Loading data...',
    id: 'mercury.loading_data'
  },
  log_in_or_create_wallet: {
    defaultMessage: 'Log In or Create Wallet',
    id: 'mercury.log_in_or_create_wallet'
  },
  login_to_see_open_orders: {
    defaultMessage: 'Log In to See Open Orders',
    id: 'mercury.login_to_see_open_orders'
  },
  login_to_see_order_history: {
    defaultMessage: 'Log In to See Order History',
    id: 'mercury.login_to_see_order_history'
  },
  login_to_see_portfolio: {
    defaultMessage: 'Log In to See Portfolio',
    id: 'mercury.login_to_see_portfolio'
  },
  login_to_see_positions: {
    defaultMessage: 'Log In to See Positions',
    id: 'mercury.login_to_see_positions'
  },
  login_to_see_trade_history: {
    defaultMessage: 'Log In to See Trade History',
    id: 'mercury.login_to_see_trade_history'
  },
  long: {
    defaultMessage: 'Long',
    id: 'mercury.long'
  },
  maker_fee: {
    defaultMessage: 'Current Maker Fee',
    id: 'mercury.maker_fee'
  },
  maker_taker_month: {
    defaultMessage: 'Maker Taker Month',
    id: 'mercury.maker_taker_month'
  },
  margin: {
    defaultMessage: 'Margin',
    id: 'mercury.margin'
  },
  margin_add_to_bail_margin_call: {
    defaultMessage: 'Add {money} to meet your margin call',
    id: 'mercury.margin_add_to_bail_margin_call-1'
  },
  margin_adjusted_margin: {
    defaultMessage: 'Adjusted Collateral',
    id: 'mercury.margin_adjusted_margin'
  },
  margin_adjusted_margin_tooltip: {
    defaultMessage: 'Amount of collateral locked to the position after adjustment',
    id: 'mercury.margin_adjusted_margin_tooltip'
  },
  margin_call_liquidation_price: {
    defaultMessage: 'Margin Call/Liquidation Price',
    id: 'mercury.  margin_call_liquidation_price'
  },
  margin_close_description: {
    defaultMessage: 'Place a {side} order to close this position',
    id: 'mercury.margin_close_description'
  },
  margin_close_position: {
    defaultMessage: 'Close Position',
    id: 'mercury.margin_close_position'
  },
  margin_collateral: {
    defaultMessage: 'Margin Collateral',
    id: 'mercury.margin_collateral'
  },
  margin_current_margin: {
    defaultMessage: 'Current Collateral',
    id: 'mercury.margin_current_margin'
  },
  margin_disabled_side_description: {
    defaultMessage:
      'Please close your {side} Position in the {pair} market to open {oppositeSide} Positions.',
    id: 'mercury.margin_disabled_side_description'
  },
  margin_disabled_side_header: {
    defaultMessage: 'Margin {side} Unavailable',
    id: 'mercury.margin_disabled_side_header'
  },
  margin_leverage: {
    defaultMessage: 'Leverage',
    id: 'mercury.margin_leverage'
  },
  margin_new_currency_button: {
    defaultMessage: 'Trade Now',
    id: 'mercury.margin_new_currency_button'
  },
  margin_new_currency_description: {
    defaultMessage:
      'Amplify your trading power. Get up to {leverage}X leverage when trading {baseName} ({baseCode}) - {counterName} ({counterCode}).',
    id: 'mercury.margin_new_currency_description1'
  },
  margin_new_currency_title: {
    defaultMessage: '{base} -> {counter} Now Margin Trading',
    id: 'mercury.margin_new_currency_title'
  },
  margin_new_currency_upto: {
    defaultMessage: 'Up to {leverage}x',
    id: 'mercury.margin_new_currency_upto'
  },
  margin_onboarding_agreement_cta: {
    defaultMessage: 'Enable Margin Trading',
    id: 'mercury.margin_onboarding_agreement_cta'
  },
  margin_onboarding_agreement_description: {
    defaultMessage:
      'I confirm that I have read, understand, and agree to the {link} in this Agreement.',
    id: 'mercury.margin_onboarding_agreement_description'
  },
  margin_onboarding_agreement_title: {
    defaultMessage: 'Margin Trading Agreement',
    id: 'mercury.margin_onboarding_agreement_title1'
  },
  margin_onboarding_amount_description: {
    defaultMessage:
      'Enjoy up to 5X leverage, or five times the buying-selling power of a typical order. With 1 BTC on hand, you can buy or sell up to 5 BTC by trading on margin.',
    id: 'mercury.margin_onboarding_amount_description1'
  },
  margin_onboarding_amount_title: {
    defaultMessage: 'How much leverage can I get?',
    id: 'mercury.margin_onboarding_amount_title1'
  },
  margin_onboarding_collateral_description: {
    defaultMessage:
      'To open a margin position, you can use collateral in either the base or quote currency of the pair. For example, to buy BTC-USD on margin, you can use BTC or USD as collateral.',
    id: 'mercury.margin_onboarding_collateral_description1'
  },
  margin_onboarding_collateral_title: {
    defaultMessage: 'What collateral do I need and how much?',
    id: 'mercury.margin_onboarding_collateral_title1'
  },
  margin_onboarding_live_cta: {
    defaultMessage: 'Learn More ->',
    id: 'mercury.margin_onboarding_live_cta'
  },
  margin_onboarding_live_description: {
    defaultMessage:
      'Trade with leverage in the most popular crypto pairs. Margin trading could mean higher rewards although with that comes higher risks.',
    id: 'mercury.margin_onboarding_live_description1'
  },
  margin_onboarding_live_title: {
    defaultMessage: 'Margin Trading Now Live!',
    id: 'mercury.margin_onboarding_live_title1'
  },
  margin_onboarding_positions_description: {
    defaultMessage:
      'Be aware of the margin call price--when you should top up your collateral--and the liquidation price--when your position is forced liquidated. Avoid these outcomes by setting stop losses, making sure positions are well collateralized and closing positions during high market volatility.',
    id: 'mercury.margin_onboarding_positions_description1'
  },
  margin_onboarding_positions_title: {
    defaultMessage: 'How do I manage a margin position?',
    id: 'mercury.margin_onboarding_positions_title1'
  },
  margin_only: {
    defaultMessage: 'Margin Only',
    id: 'mercury.margin_only'
  },
  margin_stop_loss_warning: {
    defaultMessage:
      'Mark price to {markPrice} will trigger market {side} order. Estimated loss: {estimatedLoss}.',
    id: 'mercury.margin_stop_loss_warning'
  },
  margin_take_profit_warning: {
    defaultMessage:
      'Mark price to {markPrice} will trigger market {side} order. Estimated profit: {estimatedProfit}.',
    id: 'mercury.margin_take_profit_warning'
  },
  margin_try_description: {
    defaultMessage:
      'Blockchain.com now let’s you open long or short positions with leverage. {link}',
    id: 'mercury.margin_try_description'
  },
  margin_try_title: {
    defaultMessage: 'Introducing Margin',
    id: 'mercury.margin_try_title1'
  },
  margin_update_collateral: {
    defaultMessage: 'Update Collateral',
    id: 'mercury.margin_update_collateral'
  },
  mark_price: {
    defaultMessage: 'Mark Price',
    id: 'mercury.mark_price'
  },
  mark_price_tooltip: {
    defaultMessage: 'A weighted index price, sourced from multiple exchanges',
    id: 'mercury.mark_price_tooltip'
  },
  market: {
    defaultMessage: 'Market',
    id: 'mercury.market'
  },
  market_cap: {
    defaultMessage: 'Market Cap',
    id: 'mercury.market_cap'
  },
  market_closed: {
    defaultMessage: 'Market Closed',
    id: 'mercury.market_closed'
  },
  market_halt: {
    defaultMessage: 'Market Halted',
    id: 'mercury.market_halt'
  },
  market_halt_freeze: {
    defaultMessage: 'Halt Freeze',
    id: 'mercury.market_halt_freeze'
  },
  market_open: {
    defaultMessage: 'Market Open',
    id: 'mercury.market_open'
  },
  market_status: {
    defaultMessage: 'Market Status',
    id: 'mercury.market_status'
  },
  market_system_outage: {
    defaultMessage: 'System Outage',
    id: 'mercury.market_system_outage'
  },
  markets: {
    defaultMessage: 'Markets',
    id: 'mercury.markets'
  },
  max: {
    defaultMessage: 'Max',
    id: 'mercury.max'
  },
  min_age: {
    defaultMessage: 'You must be 18 or older',
    id: 'mercury.min_age'
  },
  mobile_phone_code: {
    defaultMessage: 'Mobile phone code',
    id: 'mercury.mobile_phone_code'
  },
  mobile_phone_number: {
    defaultMessage: 'Mobile phone number',
    id: 'mercury.mobile_phone_number'
  },
  mobile_phone_number_desc: {
    defaultMessage: 'Uses codes sent via SMS',
    id: 'mercury.mobile_phone_number_desc'
  },
  mobile_phone_number_setup: {
    defaultMessage:
      "Enter your mobile number and click on 'Send'. A verification code will be sent.",
    id: 'mercury.mobile_phone_number_setup'
  },
  modal_close: {
    defaultMessage: 'to close',
    id: 'mercury.modal_close'
  },
  modal_hit: {
    defaultMessage: 'Hit',
    id: 'mercury.modal_hit'
  },
  month_1: {
    defaultMessage: 'January',
    id: 'month_1'
  },
  month_10: {
    defaultMessage: 'October',
    id: 'month_10'
  },
  month_11: {
    defaultMessage: 'November',
    id: 'month_11'
  },
  month_12: {
    defaultMessage: 'December',
    id: 'month_12'
  },
  month_2: {
    defaultMessage: 'February',
    id: 'month_2'
  },
  month_3: {
    defaultMessage: 'March',
    id: 'month_3'
  },
  month_4: {
    defaultMessage: 'April',
    id: 'month_4'
  },
  month_5: {
    defaultMessage: 'May',
    id: 'month_5'
  },
  month_6: {
    defaultMessage: 'June',
    id: 'month_6'
  },
  month_7: {
    defaultMessage: 'July',
    id: 'month_7'
  },
  month_8: {
    defaultMessage: 'August',
    id: 'month_8'
  },
  month_9: {
    defaultMessage: 'September',
    id: 'month_9'
  },
  most_popular: {
    defaultMessage: 'Most Popular',
    id: 'mercury.most_popular'
  },
  new: {
    defaultMessage: 'New',
    id: 'mercury.new'
  },
  new_entities_verify_cta: {
    defaultMessage: 'Verify Now',
    id: 'mercury.new_entities_verify_cta'
  },
  new_entities_verify_subtitle: {
    defaultMessage:
      'Verify to get full access. To continue trading with full functionality on the Exchange, please confirm your identity. Understand the limits of different account types {link}.',
    id: 'mercury.new_entities_verify_subtitle'
  },
  new_entities_verify_title: {
    defaultMessage: 'Verify to get full access',
    id: 'mercury.new_entities_verify_title'
  },
  next_veriff: {
    defaultMessage: 'Next - Verify Your Identity',
    id: 'mercury.next_veriff'
  },
  no: {
    defaultMessage: 'No',
    id: 'mercury.no'
  },
  no_balance: {
    defaultMessage: 'Your available {crypto} balance is 0',
    id: 'mercury.no_balance'
  },
  no_currencies: {
    defaultMessage: 'No Currencies Found',
    id: 'mercury.no_currencies'
  },
  no_open_orders: {
    defaultMessage: 'No Open {value} Orders',
    id: 'mercury.no_open_orders'
  },
  no_open_orders_subheading: {
    defaultMessage: 'To see past orders, click the Order History tab.',
    id: 'mercury.no_open_orders_subheading'
  },
  no_open_orders_with_filter: {
    defaultMessage:
      'To see open orders, click the check box off for “Show only {value}." To see past orders, click the Order History tab.',
    id: 'mercury.no_open_orders_with_filter'
  },
  no_open_positions: {
    defaultMessage: 'No Open {value} Positions',
    id: 'mercury.no_open_positions'
  },
  no_open_positions_subheading: {
    defaultMessage: 'To see past positions, click the Trade History tab.',
    id: 'mercury.no_open_positions_subheading'
  },
  no_open_positions_with_filter: {
    defaultMessage:
      'To open positions, click the check box off for “Show only {value}." To see past positions, click the Trade History tab.',
    id: 'mercury.no_open_positions_with_filter'
  },
  no_order_history: {
    defaultMessage: 'No {value} Order History',
    id: 'mercury.no_order_history'
  },
  no_results: {
    defaultMessage: 'No Results',
    id: 'mercury.no_results'
  },
  no_trade_history: {
    defaultMessage: 'No {value} Trade History',
    id: 'mercury.no_trade_history'
  },
  no_withdrawable_currencies: {
    defaultMessage: 'No balances are currently withdrawable',
    id: 'mercury.no_withdrawable_currencies'
  },
  none: {
    defaultMessage: 'None',
    id: 'mercury.none'
  },
  not_connected: {
    defaultMessage: 'Not Connected',
    id: 'mercury.not_connected'
  },
  not_supported: {
    defaultMessage: 'Not Supported',
    id: 'mercury.not_supported'
  },
  not_verified: {
    defaultMessage: 'Not Verified',
    id: 'mercury.not_verified'
  },
  notifications: {
    defaultMessage: 'Notifications',
    id: 'mercury.notifications'
  },
  notify_email: {
    defaultMessage: 'Notify Me When It’s Available',
    id: 'mercury.notify_email'
  },
  ok_api_key_activation: {
    defaultMessage: 'Enable your key by clicking the link in your email',
    id: 'mercury.ok_api_key_activation'
  },
  ok_change_password: {
    defaultMessage: 'Password has been changed',
    id: 'mercury.ok_change_password'
  },
  ok_copy: {
    defaultMessage: 'Copied!',
    id: 'mercury.ok_copy'
  },
  ok_email_not_verified: {
    defaultMessage: 'We sent you an email with a verification link. Follow the link to continue.',
    id: 'mercury.ok_email_not_verifed'
  },
  ok_email_verified: {
    defaultMessage: 'Email address verified',
    id: 'mercury.ok_not_verifed'
  },
  ok_order_created: {
    defaultMessage: 'Order created',
    id: 'mercury.ok_order_created'
  },
  ok_order_filled: {
    defaultMessage: 'Order fully filled',
    id: 'mercury.ok_order_filled'
  },
  ok_order_partially_filled: {
    defaultMessage: 'Order partially filled',
    id: 'mercury.ok_order_partially_filled'
  },
  ok_order_pending: {
    defaultMessage: 'Order pending',
    id: 'mercury.ok_order_pending'
  },
  ok_request_history: {
    defaultMessage: 'Your history download is being processed',
    id: 'mercury.ok_request_history'
  },
  ok_request_history_desc: {
    defaultMessage: 'Check your email {value} for your download',
    id: 'mercury.ok_request_history_desc'
  },
  ok_reset_password: {
    defaultMessage: 'Password updated',
    id: 'mercury.ok_reset_password'
  },
  ok_save_preferences: {
    defaultMessage: 'Settings have been changed',
    id: 'mercury.ok_save_preferences'
  },
  ok_signout: {
    defaultMessage: 'Signed out.',
    id: 'mercury.ok_signout'
  },
  ok_simple_trade_order: {
    defaultMessage: 'Order confirmed',
    id: 'mercury.ok_simple_trade_order'
  },
  ok_verify_totp: {
    defaultMessage: 'Success, please backup your codes',
    id: 'mercury.ok_verify_totp'
  },
  ok_whitelist_added: {
    defaultMessage: 'Successfully whitelisted address',
    id: 'mercury.ok_whitelist_added'
  },
  ok_whitelist_disabled: {
    defaultMessage: 'Successfully disabled whitelist addresses',
    id: 'mercury.ok_whitelist_disabled'
  },
  ok_whitelist_removed: {
    defaultMessage: 'Success, your address has been removed',
    id: 'mercury.ok_whitelist_removed'
  },
  okay: {
    defaultMessage: 'Okay',
    id: 'mercury.okay'
  },
  on: {
    defaultMessage: 'On',
    id: 'mercury.on'
  },
  open_orders: {
    defaultMessage: 'Open orders',
    id: 'mercury.open_orders'
  },
  or: {
    defaultMessage: 'or',
    id: 'mercury.or'
  },
  order_book: {
    defaultMessage: 'Order Book',
    id: 'mercury.order_book'
  },
  order_confirmation_cancel: {
    defaultMessage: 'Cancel Order',
    id: 'mercury.order_confirmation_cancel'
  },
  order_confirmation_submit: {
    defaultMessage: 'Submit Order',
    id: 'mercury.order_confirmation_submit'
  },
  order_tif_fok: {
    defaultMessage: 'Fill Or Kill',
    id: 'mercury.order_tif_fok'
  },
  order_tif_gtc: {
    defaultMessage: 'Good Til Cancelled',
    id: 'mercury.order_tif_gtc'
  },
  order_tif_gtd: {
    defaultMessage: 'Good Til Date',
    id: 'mercury.order_tif_gtd'
  },
  order_tif_ioc: {
    defaultMessage: 'Immediate Or Cancel',
    id: 'mercury.order_tif_ioc'
  },
  order_time: {
    defaultMessage: 'Order Time',
    id: 'mercury.order_time'
  },
  order_type_limit: {
    defaultMessage: 'Limit',
    id: 'mercury.order_type_limit'
  },
  order_type_market: {
    defaultMessage: 'Market',
    id: 'mercury.order_type_market'
  },
  order_type_stop: {
    defaultMessage: 'Stop',
    id: 'mercury.order_type_stop'
  },
  order_type_stop_limit: {
    defaultMessage: 'Stop-Limit',
    id: 'mercury.order_type_stop_limit'
  },
  orders: {
    defaultMessage: 'Order History',
    id: 'mercury.orders'
  },
  orders_word: {
    defaultMessage: 'orders',
    id: 'mercury.orders_word'
  },
  pair: {
    defaultMessage: 'Pair',
    id: 'mercury.pair'
  },
  password_strength_tooltip: {
    defaultMessage: '{strength}. Use 8+ characters',
    id: 'mercury.password_strength_tooltip'
  },
  pending_deposits: {
    defaultMessage: 'Pending Deposits',
    id: 'mercury.pending_deposits'
  },
  pending_gold_review: {
    defaultMessage: 'Full Access Level Pending Review',
    id: 'mercury.pending_gold_review-1'
  },
  pending_lowercase: {
    defaultMessage: 'Pending',
    id: 'mercury.pending_lowercase'
  },
  pending_review: {
    defaultMessage: 'Pending Review',
    id: 'mercury.pending_review'
  },
  pending_withdrawals: {
    defaultMessage: 'Pending Withdrawals',
    id: 'mercury.pending_withdrawals'
  },
  per_week: {
    defaultMessage: '/ week',
    id: 'mercury.per_week'
  },
  per_year: {
    defaultMessage: '/ year',
    id: 'mercury.per_year'
  },
  place_order: {
    defaultMessage: 'Preview {currency} Order',
    id: 'mercury.place_order_1'
  },
  placeholder_code: {
    defaultMessage: '{length} digit code',
    id: 'mercury.placeholder_code'
  },
  placeholder_first_line: {
    defaultMessage: 'Street and number, P.O box, c/o.',
    id: 'mercury.placeholder_first_line'
  },
  placeholder_first_line_us: {
    defaultMessage: 'Address Line 1',
    id: 'mercury.placeholder_first_line_us'
  },
  placeholder_password_new: {
    defaultMessage: '8+ characters',
    id: 'mercury.placeholder_password_new'
  },
  placeholder_price: {
    defaultMessage: '0.00',
    id: 'mercury.placeholder_price'
  },
  placeholder_quantity: {
    defaultMessage: '0.00',
    id: 'mercury.placeholder_quantity'
  },
  placeholder_search: {
    defaultMessage: 'Search',
    id: 'mercury.placeholder_search'
  },
  placeholder_search_coins: {
    defaultMessage: 'Search coins',
    id: 'mercury.placeholder_search_coins'
  },
  placeholder_second_line: {
    defaultMessage: 'Flat, suite, unit, building, floor, etc.',
    id: 'mercury.placeholder_second_line'
  },
  placeholder_second_line_us: {
    defaultMessage: 'Address Line 2 (Optional)',
    id: 'mercury.placeholder_second_line_us'
  },
  placeholder_select_an_option: {
    defaultMessage: 'Select an option',
    id: 'mercury.placeholder_select_an_option'
  },
  placeholder_signin_verif: {
    defaultMessage: '6-digit code',
    id: 'mercury.placeholder_signin_verif'
  },
  placeholder_verify_2fa_email_code_label: {
    defaultMessage: '6-alphanumeric code',
    id: 'mercury.placeholder_verify_2fa_email_code_label'
  },
  placeholder_whitelist: {
    defaultMessage: 'ex: 192.168.1.1, 194.23.22.123, 127.0.0.1',
    id: 'mercury.placeholder_whitelist'
  },
  platinum: {
    defaultMessage: 'Platinum',
    id: 'mercury.platinum'
  },
  portfolio: {
    defaultMessage: 'Portfolio',
    id: 'mercury.portfolio'
  },
  portfolio_empty_cta: {
    defaultMessage: 'Deposit now',
    id: 'mercury.portfolio_empty_cta1'
  },
  portfolio_empty_subtitle: {
    defaultMessage: 'Once you start trading and holding crypto, your breakdown will show up here.',
    id: 'mercury.portfolio_empty_subtitle_1'
  },
  portfolio_empty_title: {
    defaultMessage: 'It’s a bit quiet in here.',
    id: 'mercury.portfolio_empty_title'
  },
  position_id: {
    defaultMessage: 'Position ID',
    id: 'mercury.positionId'
  },
  positions: {
    defaultMessage: 'Positions',
    id: 'mercury.positions'
  },
  positions_cash: {
    defaultMessage: 'Cash',
    id: 'mercury.positions_cash1'
  },
  price: {
    defaultMessage: 'Price',
    id: 'mercury.price'
  },
  price_24h_high: {
    defaultMessage: '24h High',
    id: 'mercury.price_24h_high'
  },
  price_24h_low: {
    defaultMessage: '24h Low',
    id: 'mercury.price_24h_low'
  },
  price_24hrs_change: {
    defaultMessage: '24hrs',
    id: 'mercury.price_24hrs_change'
  },
  prompt_signin: {
    defaultMessage: 'Login or Sign Up to Trade',
    id: 'mercury.prompt_signin'
  },
  realised_PNL: {
    defaultMessage: 'Realised PNL',
    id: 'mercury.realised_PNL'
  },
  recent_trades: {
    defaultMessage: 'Recent Trades',
    id: 'mercury.recent_trades'
  },
  recipient: {
    defaultMessage: 'Recipient',
    id: 'mercury.recipient'
  },
  recipient_address: {
    defaultMessage: 'Recipient Address',
    id: 'mercury.recipient_address'
  },
  recipient_name: {
    defaultMessage: 'Recipient Name',
    id: 'mercury.recipient_name'
  },
  recurring_fees: {
    defaultMessage: 'Recurring fees',
    id: 'mercury.recurring_fees'
  },
  refer_a_friend: {
    defaultMessage: 'Refer a Friend',
    id: 'mercury.refer_a_friend'
  },
  referral_share: {
    defaultMessage:
      'Join me and sign up to the Blockchain.com Exchange with referral code "{code}", and get a bonus in crypto!%0D%0A%0D%0Ahttps://exchange.blockchain.com/trade',
    id: 'mercury.referral_share1'
  },
  relink_bank: {
    defaultMessage: 'Relink Bank Account',
    id: 'mercury.relink_bank'
  },
  remaining: {
    defaultMessage: 'Remaining',
    id: 'mercury.remaining'
  },
  remove: {
    defaultMessage: 'Remove',
    id: 'mercury.remove'
  },
  request_sms_code: {
    defaultMessage: 'Request SMS Code',
    id: 'mercury.request_sms_code'
  },
  requirements_account_purpose: {
    defaultMessage: 'Purpose of Account',
    id: 'mercury.requirements_account_purpose'
  },
  requirements_address: {
    defaultMessage: 'Address',
    id: 'mercury.requirements_address'
  },
  requirements_address_proof: {
    defaultMessage: 'Proof of Address',
    id: 'mercury.requirements_address_proof'
  },
  requirements_dob: {
    defaultMessage: 'Date of Birth',
    id: 'mercury.requirements_dob'
  },
  requirements_email: {
    defaultMessage: 'Verified Email',
    id: 'mercury.requirements_email'
  },
  requirements_first_name: {
    defaultMessage: 'Legal First Name',
    id: 'mercury.requirements_first_name'
  },
  requirements_funds_source: {
    defaultMessage: 'Source of Funds',
    id: 'mercury.requirements_funds_source'
  },
  requirements_id: {
    defaultMessage: 'Govt. Issued ID',
    id: 'mercury.requirements_id'
  },
  requirements_last_name: {
    defaultMessage: 'Legal Last Name',
    id: 'mercury.requirements_last_name'
  },
  requirements_occupation: {
    defaultMessage: 'Occupation',
    id: 'mercury.requirements_occupation'
  },
  requirements_photo: {
    defaultMessage: 'Portrait Photo',
    id: 'mercury.requirements_photo'
  },
  requires: {
    defaultMessage: 'Requires',
    id: 'mercury.requires'
  },
  resend_code: {
    defaultMessage: 'Resend code',
    id: 'mercury.resend_code'
  },
  resend_link: {
    defaultMessage: 'Send Again',
    id: 'mercury.resend_link1'
  },
  routing_number: {
    defaultMessage: 'Routing Number',
    id: 'mercury.routing_number'
  },
  routing_number_upt: {
    defaultMessage: 'BIC Code',
    id: 'mercury.routing_number_upt'
  },
  search_shortcut: {
    defaultMessage: 'Shift + /',
    id: 'mercury.search_shortcut'
  },
  security: {
    defaultMessage: 'Security',
    id: 'mercury.security'
  },
  select_all_that_apply: {
    defaultMessage: '(Select all that apply)',
    id: 'mercury.select_all_that_apply'
  },
  select_currency: {
    defaultMessage: 'Select a Currency',
    id: 'mercury.select_currency'
  },
  select_deposit_method: {
    defaultMessage: 'Select a Deposit Method',
    id: 'mercury.select_deposit_method'
  },
  select_only_one: {
    defaultMessage: '(Select only one)',
    id: 'mercury.select_only_one'
  },
  select_show_notifications: {
    defaultMessage: 'Choose whether to show notifications',
    id: 'mercury.select_show_notifications'
  },
  select_withdraw_method: {
    defaultMessage: 'Select withdraw method',
    id: 'mercury.select_withdraw_method'
  },
  sell: {
    defaultMessage: 'Sell',
    id: 'mercury.sell'
  },
  send: {
    defaultMessage: 'Send',
    id: 'mercury.send'
  },
  sent_to: {
    defaultMessage: 'Sent to',
    id: 'mercury.sent_to'
  },
  settings: {
    defaultMessage: 'Settings',
    id: 'mercury.settings'
  },
  share: {
    defaultMessage: 'Share',
    id: 'mercury.share'
  },
  short: {
    defaultMessage: 'Short',
    id: 'mercury.short'
  },
  short_x_day: {
    defaultMessage: '{x}d',
    id: 'mercury.short_x_day'
  },
  short_x_hour: {
    defaultMessage: '{x}h',
    id: 'mercury.short_x_hour'
  },
  short_x_minute: {
    defaultMessage: '{x}m',
    id: 'mercury.short_x_minute'
  },
  side: {
    defaultMessage: 'Side',
    id: 'mercury.side'
  },
  side_open_orders: {
    defaultMessage: 'Open Orders',
    id: 'mercury.side_open_orders'
  },
  signup_unavailable: {
    defaultMessage: 'Due to local laws, the Exchange cannot operate in your region.',
    id: 'mercury.signup_unavailable-1'
  },
  silver: {
    defaultMessage: 'Limited Access',
    id: 'mercury.silver-1'
  },
  simple_trade: {
    defaultMessage: 'Simple Trade',
    id: 'mercury.simple_trade'
  },
  simple_trade_bank_transfer_button: {
    defaultMessage: 'I have deposited {amount}',
    id: 'mercury.simple_trade_bank_transfer_button'
  },
  simple_trade_bank_transfer_instructions: {
    defaultMessage:
      'Securely transfer exactly {amount} {currency} from your bank account to Blockchain.com.',
    id: 'mercury.simple_trade_bank_transfer_instructions'
  },
  simple_trade_bank_transfer_option_subtitle: {
    defaultMessage: 'Send a bank transfer',
    id: 'mercury.simple_trade_bank_transfer_option_subtitle'
  },
  simple_trade_bank_transfer_option_title: {
    defaultMessage: '{currency} Bank Transfer',
    id: 'mercury.simple_trade_bank_transfer_option_title'
  },
  simple_trade_confirm_bank_transfer: {
    defaultMessage:
      'You are buying {buying} ({counter}) with a {currency} bank transfer. Please confirm the order.',
    id: 'mercury.simple_trade_confirm_bank_transfer'
  },
  simple_trade_confirm_funds: {
    defaultMessage:
      'You are buying {buying} ({counter}), with your {account} account. Please confirm the order.',
    id: 'mercury.simple_trade_confirm_funds'
  },
  simple_trade_deposit_description: {
    defaultMessage:
      'In order to deposit, you need to first make a deposit so that we can link your bank account.',
    id: 'mercury.simple_trade_deposit_description'
  },
  simple_trade_deposit_title: {
    defaultMessage: 'Link your bank account to deposit.',
    id: 'mercury.simple_trade_deposit_title'
  },
  simple_trade_funds_option_subtitle: {
    defaultMessage: '{balance} Available',
    id: 'mercury.simple_trade_funds_option_subtitle'
  },
  simple_trade_history: {
    defaultMessage: 'Simple Trade History',
    id: 'mercury.simple_trade_history'
  },
  simple_trade_ineligible_body: {
    defaultMessage: 'This feature is currently unavailable in your region.',
    id: 'mercury.simple_trade_ineligible_body'
  },
  simple_trade_ineligible_title: {
    defaultMessage: 'Feature Unavailable',
    id: 'mercury.simple_trade_ineligible_title'
  },
  simple_trade_pending_order_description: {
    defaultMessage: 'Your buy order for {buy} of {counter} is awaiting payment from your deposit.',
    id: 'mercury.simple_trade_pending_order_description'
  },
  simple_trade_pending_order_title1: {
    defaultMessage: 'Order Placed - Awaiting Deposit',
    id: 'mercury.simple_trade_pending_order_title'
  },
  simple_trade_promo: {
    defaultMessage:
      'A quick and easy way to buy and sell crypto without having to use an order entry ticket. Withdrawals coming soon!',
    id: 'mercury.simple_trade_promo'
  },
  simple_trade_upgrade_description: {
    defaultMessage:
      "Before you can start buying, we need to verify your identity. Don't worry, it'll only take a minute.",
    id: 'mercury.simple_trade_upgrade_description'
  },
  simple_trade_upgrade_title: {
    defaultMessage: 'First things first',
    id: 'mercury.simple_trade_upgrade_title'
  },
  sort_code: {
    defaultMessage: 'Sort Code',
    id: 'mercury.sort_code'
  },
  spot: {
    defaultMessage: 'Spot',
    id: 'mercury.spot'
  },
  stablecoin_balance: {
    defaultMessage: '{currencyName} balance contains {currency} and {currency} Stablecoins',
    id: 'mercury.stablecoin_balance1'
  },
  stablecoins_unavailable: {
    defaultMessage: 'Oops! Stablecoins unavailable.',
    id: 'mercury.stablecoins_unavailable'
  },
  status: {
    defaultMessage: 'Status',
    id: 'mercury.status'
  },
  stop_loss: {
    defaultMessage: 'Stop Loss',
    id: 'mercury.stop_loss'
  },
  strong: {
    defaultMessage: 'Strong',
    id: 'mercury.strong'
  },
  sub_title_backup_2fa: {
    defaultMessage:
      'Keep these backup codes safe but accessible. 5 single-use codes are active at this time, but you can generate more as needed. Each code can only be used once.',
    id: 'mercury.sub_title_backup_2fa'
  },
  sub_title_blockchain_wallet: {
    defaultMessage:
      'Instantly send and receive crypto between your Exchange account and your Blockchain.com Wallet.',
    id: 'mercury.sub_title_blockchain_wallet'
  },
  sub_title_change_email: {
    defaultMessage:
      'We have sent a code to {oldEmail} and {newEmail}. You will need to enter these 2 unique codes to update your email.',
    id: 'mercury.sub_title_change_email'
  },
  sub_title_change_password: {
    defaultMessage:
      'Protect your account with a strong and unique password. We recommend changing your password regularly',
    id: 'mercury.sub_title_change_password'
  },
  sub_title_disable_2fa: {
    defaultMessage:
      'Turning off 2-factor authentication will remove the extra security on your account, and you’ll only use your password to log in',
    id: 'mercury.sub_title_disable_2fa'
  },
  sub_title_disable_whitelisting: {
    defaultMessage:
      'By disabling this security feature your whitelisted addresses will be removed.',
    id: 'mercury.sub_title_disable_whitelisting'
  },
  sub_title_edd: {
    defaultMessage: 'For legal reasons, we need a little bit more information about you.',
    id: 'mercury.sub_title_edd'
  },
  sub_title_final_gold: {
    defaultMessage:
      'A Blockchain.com team member is validating your information. We will send you an email when this is complete. As long as there are no delays, you should hear from us in under ten minutes.',
    id: 'mercury.sub_title_final_gold'
  },
  sub_title_generate_codes_2fa: {
    defaultMessage:
      'If you generate a set of new backup codes, none of your current backup codes will work.',
    id: 'mercury.sub_title_generate_codes_2fa'
  },
  sub_title_limits: {
    defaultMessage:
      'Whether you are brand new or a Crypto Pro, we’ve got levels to meet all your needs.',
    id: 'mercury.sub_title_limits'
  },
  sub_title_local_currency: {
    defaultMessage: 'All charts and currencies will be converted to this denomination.',
    id: 'mercury.sub_title_local_currency'
  },
  sub_title_more_info: {
    defaultMessage:
      'We need additional information from you before you can start trading. Continue below to complete these final steps',
    id: 'mercury.sub_title_more_info'
  },
  sub_title_need_more_verification_info: {
    defaultMessage:
      'We need to confirm your identity with a government issued ID and selfie. Before proceeding, make sure you have one of the following forms of ID handy and your camera is turned on.',
    id: 'mercury.sub_title_need_more_verification_info'
  },
  sub_title_password_wall_2fa: {
    defaultMessage: 'For security, please enter your password.',
    id: 'mercury.sub_title_password_wall_2fa'
  },
  sub_title_personal_information: {
    defaultMessage:
      'Before you can start trading, we need to verify your identity. Don’t worry, it’ll only take a minute.',
    id: 'mercury.sub_title_personal_information1'
  },
  sub_title_scheduled_maintenance: {
    defaultMessage:
      'The Exchange will enter scheduled system maintenance at {time} for approximately {hours} hour(s).',
    id: 'mercury.sub_title_scheduled_maintenance-2'
  },
  sub_title_select_2fa: {
    defaultMessage:
      'Protect your account with a two-factor method. Add an extra layer of security.',
    id: 'mercury.sub_title_select_2fa'
  },
  sub_title_setup_2fa: {
    defaultMessage:
      'If you don’t already have an authenticator app, download Google Authenticator from the App Store or Play Store.',
    id: 'mercury.sub_title_setup_2fa'
  },
  sub_title_setup_whitelist: {
    defaultMessage:
      'This security feature limits withdrawals to only addresses you have whitelisted or to your Blockchain Wallet address.',
    id: 'mercury.sub_title_setup_whitelist'
  },
  sub_title_show_notifications: {
    defaultMessage: 'Display order activity stacked notifications.',
    id: 'mercury.label_show_notifications'
  },
  sub_title_signout: {
    defaultMessage:
      'This will log off all sessions on your account except the current session you are logged into now.',
    id: 'mercury.sub_title_signout'
  },
  sub_title_ssn: {
    defaultMessage:
      'The security of your information is very important to us. We need this information in order to verify your identity.',
    id: 'mercury.sub_title_ssn'
  },
  sub_title_success_2fa: {
    defaultMessage:
      'From now on, you will need the 2FA code from your device to login and to withdraw funds.',
    id: 'mercury.sub_title_success_2fa'
  },
  sub_title_trading_blocked: {
    defaultMessage:
      'Your current location or the location of your residence does not support trading of this symbol at this time.',
    id: 'mercury.sub_title_trading_blocked'
  },
  sub_title_trading_halted1: {
    defaultMessage:
      'This symbol is currently in the auction period. Only limit, stop and stop limit order will be accepted but they will not be matched. {link}',
    id: 'mercury.sub_title_trading_halted1'
  },
  sub_title_trading_will_halt: {
    defaultMessage: '{currency} deposit and trading will be halted beginning {time}',
    id: 'mercury.sub_title_trading_will_halt'
  },
  sub_title_verify_2fa: {
    defaultMessage: 'Please verify 2fa via your Google Authenticator App & Email Address.',
    id: 'mercury.sub_title_verify_2fa1'
  },
  sub_title_verify_email: {
    defaultMessage:
      'We sent an email to {email} with a verification link. Follow the link to continue.',
    id: 'mercury.sub_title_verify_email'
  },
  submit: {
    defaultMessage: 'Submit',
    id: 'mercury.submit'
  },
  support: {
    defaultMessage: 'Support',
    id: 'mercury.support'
  },
  support_center: {
    defaultMessage: 'Support Center',
    id: 'mercury.support_center'
  },
  symbol: {
    defaultMessage: 'Symbol',
    id: 'mercury.symbol'
  },
  take_profit: {
    defaultMessage: 'Take Profit',
    id: 'mercury.take_profit'
  },
  take_profit_stop_loss: {
    defaultMessage: 'TP/SL',
    id: 'mercury.take_profit_stop_loss'
  },
  taker_fee: {
    defaultMessage: 'Current Taker Fee',
    id: 'mercury.taker_fee'
  },
  tax_center: {
    defaultMessage: 'Tax Center',
    id: 'mercury.tax_center'
  },
  tax_center_card_one_description: {
    defaultMessage: 'Get the full transaction history from your entire trading account.',
    id: 'mercury.tax_center_card_one_description'
  },
  tax_center_card_one_title: {
    defaultMessage: 'Export your transaction history',
    id: 'mercury.tax_center_card_one_title'
  },
  tax_center_card_two_description: {
    defaultMessage:
      'We have partnered with TurboTax and Cointracker to simplify your tax reporting.',
    id: 'mercury.tax_center_card_two_description_2'
  },
  tax_center_card_two_title: {
    defaultMessage: 'Upload to a tax center',
    id: 'mercury.tax_center_card_two_title'
  },
  tax_center_choose_tax_year: {
    defaultMessage: 'Choose tax year',
    id: 'mercury.tax_center_choose_tax_year'
  },
  tax_center_description_step_one_1: {
    defaultMessage: 'If you traded crypto in the last year, you likely owe taxes.',
    id: 'mercury.tax_center_description_step_one'
  },
  tax_center_description_step_three: {
    defaultMessage:
      'This file only contains your Blockchain.com Exchange activity. If you use other crypto services, those transactions will not appear here. If you use the Blockchain.com Wallet, you can export your Wallet transaction history by using the Wallet Tax Center.',
    id: 'mercury.tax_center_description_step_three'
  },
  tax_center_description_step_two: {
    defaultMessage:
      'Export your transaction history then manually calculate your gains/losses using your cost basis. If you want to simplify the process, use our crypto tax partner CoinTracker to get free tax reports for up to 500 transactions.',
    id: 'mercury.tax_center_description_step_two_1'
  },
  tax_center_footer: {
    defaultMessage: 'Have a Blockchain.com Wallet? {link}',
    id: 'mercury.tax_center_footer'
  },
  tax_center_footer_link: {
    defaultMessage: 'Wallet Tax Center',
    id: 'mercury.tax_center_footer_link'
  },
  tax_center_generate_export: {
    defaultMessage: 'Generate Export',
    id: 'mercury.tax_center_generate_export'
  },
  tax_center_title_step_one: {
    defaultMessage: 'Do I owe taxes on my crypto?',
    id: 'mercury.tax_center_title_step_one'
  },
  tax_center_title_step_three: {
    defaultMessage: 'What if I use other crypto services?',
    id: 'mercury.tax_center_title_step_three'
  },
  tax_center_title_step_two: {
    defaultMessage: 'How do I file?',
    id: 'mercury.tax_center_title_step_two'
  },
  tax_center_turbo_link: {
    defaultMessage: 'Visit TurboTax',
    id: 'mercury.tax_center_turbo_link'
  },
  tax_center_turbo_title: {
    defaultMessage:
      'If you’re new to crypto and don’t have much crypto activity, TurboTax helps navigate the complexity of crypto taxes. Save time by auto-importing crypto activity, plus specialized experts are available year round and can even do your taxes for you, start to finish.',
    id: 'mercury.tax_center_turbo_title'
  },
  tax_center_visit_cointracker: {
    defaultMessage: 'Visit CoinTracker',
    id: 'mercury.tax_center_visit_cointracker'
  },
  tax_center_visit_cointracker_title: {
    defaultMessage:
      'If your crypto activity is high and you have multiple wallets beyond Blockchain.com, Cointracker is fully supported in the US, Australia, UK, Canada and also provides capital gains reports for users around the World. Blockchain.com users get free tax reports for up to 500 transactions with CoinTracker.',
    id: 'mercury.tax_center_visit_cointracker_title'
  },
  terms_conditions: {
    defaultMessage: 'Terms and Conditions',
    id: 'mercury.terms_conditions'
  },
  terms_link: {
    defaultMessage: 'Terms of Service',
    id: 'mercury.terms_link'
  },
  time: {
    defaultMessage: 'Time',
    id: 'mercury.time'
  },
  time_in_force: {
    defaultMessage: 'Type',
    id: 'mercury.time_in_force'
  },
  title_approved_tier_1: {
    defaultMessage: 'Limited Access Unlocked',
    id: 'mercury.title_approved_tier_1-1'
  },
  title_backup_2fa: {
    defaultMessage: 'Backup codes',
    id: 'mercury.title_backup_2fa'
  },
  title_change_email: {
    defaultMessage: 'Confirm new email',
    id: 'mercury.title_change_email'
  },
  title_change_password: {
    defaultMessage: 'Change Password',
    id: 'mercury.title_change_password'
  },
  title_create_api_key: {
    defaultMessage: 'Create New API Key',
    id: 'mercury.title_create_api_key'
  },
  title_disable_2fa: {
    defaultMessage: 'Turn off 2 Factor Authentication?',
    id: 'mercury.title_disable_2fa'
  },
  title_disable_whitelisting: {
    defaultMessage: 'Disable Address Whitelisting',
    id: 'mercury.title_disable_whitelisting'
  },
  title_edd: {
    defaultMessage: 'Just a Few More Questions',
    id: 'mercury.title_edd'
  },
  title_final_gold: {
    defaultMessage: 'Full Access In-Review',
    id: 'mercury.title_final_gold-1'
  },
  title_generate_codes_2fa: {
    defaultMessage: 'Get new codes?',
    id: 'mercury.title_generate_codes_2fa'
  },
  title_limits: {
    defaultMessage: 'Unlock Features at Every Level',
    id: 'mercury.title_limits'
  },
  title_more_info: {
    defaultMessage: 'More Info Needed',
    id: 'mercury.title_more_info'
  },
  title_order_confirmation: {
    defaultMessage: 'Confirm your order',
    id: 'mercury.title_order_confirmation'
  },
  title_order_details: {
    defaultMessage: 'Order {order_id}',
    id: 'mercury.title_order_details'
  },
  title_password_wall_2fa: {
    defaultMessage: 'Modify Two-factor Authentication Settings',
    id: 'mercury.title_password_wall_2fa'
  },
  title_personal_information: {
    defaultMessage: 'First things first',
    id: 'mercury.title_personal_information'
  },
  title_reset_password: {
    defaultMessage: 'Reset Password',
    id: 'mercury.title_reset_password'
  },
  title_scheduled_maintenance: {
    defaultMessage: 'Scheduled Maintenance',
    id: 'mercury.title_scheduled_maintenance'
  },
  title_select_2fa: {
    defaultMessage: 'Select your method',
    id: 'mercury.title_select_2fa'
  },
  title_setup_2fa: {
    defaultMessage: 'Set up Two-factor Authentication',
    id: 'mercury.title_setup_2fa'
  },
  title_setup_whitelist: {
    defaultMessage: 'Enable Address Whitelisting',
    id: 'mercury.title_setup_whitelist'
  },
  title_signout_sessions: {
    defaultMessage: 'Log Out of all Sessions',
    id: 'mercury.title_signout_sessions'
  },
  title_ssn: {
    defaultMessage: 'SSN',
    id: 'mercury.title_ssn'
  },
  title_success_2fa: {
    defaultMessage: 'You have enabled 2FA on your account',
    id: 'mercury.title_success_2fa'
  },
  title_trading_blocked: {
    defaultMessage: 'Trading Blocked',
    id: 'mercury.title_trading_blocked'
  },
  title_trading_halted1: {
    defaultMessage: 'Auction Period',
    id: 'mercury.title_trading_halted1'
  },
  title_trading_will_halt: {
    defaultMessage: '{currency} will be halted',
    id: 'mercury.title_trading_will_halt'
  },
  title_verify_2fa: {
    defaultMessage: 'Verify Two-factor Authentication',
    id: 'mercury.title_verify_2fa'
  },
  title_verify_email: {
    defaultMessage: 'Verify your email',
    id: 'mercury.title_verify_email'
  },
  title_welcome_gold: {
    defaultMessage: 'Welcome to Full Access',
    id: 'mercury.title_welcome_gold-1'
  },
  today: {
    defaultMessage: 'Today',
    id: 'mercury.today'
  },
  tooltip_estimated_amount: {
    defaultMessage: 'Estimated amount',
    id: 'mercury.tooltip_estimated_amount'
  },
  tooltip_header_h: {
    defaultMessage: 'Highest price in the past 24 hours',
    id: 'mercury.tooltip_header_h'
  },
  tooltip_header_l: {
    defaultMessage: 'Lowest price in the past 24 hours',
    id: 'mercury.tooltip_header_l'
  },
  tooltip_header_o: {
    defaultMessage: 'Opening price 24 hours ago',
    id: 'mercury.tooltip_header_o'
  },
  tooltip_header_v: {
    defaultMessage: 'Volume in the past 24 hours',
    id: 'mercury.tooltip_header_v'
  },
  tooltip_order_confirmation_amount: {
    defaultMessage:
      'When using the MAX option, the amount is approximate since the price may vary at the time of executing the order.',
    id: 'mercury.tooltip_order_confirmation_amount'
  },
  tooltip_order_partial_fill: {
    defaultMessage: 'This order is partially filled. This is the fee for the latest fill.',
    id: 'mercury.tooltip_order_partial_fill'
  },
  tooltip_orderbook_amount: {
    defaultMessage: 'The total number of coins available at a specific price point.',
    id: 'mercury.tooltip_orderbook_amount'
  },
  tooltip_orderbook_price: {
    defaultMessage: 'Price level.',
    id: 'mercury.tooltip_orderbook_price'
  },
  tooltip_orderbook_total: {
    defaultMessage:
      'A cumulative total of the number of coins offered up to a specific price level.',
    id: 'mercury.tooltip_orderbook_total'
  },
  tooltip_sidebar_total_balance: {
    defaultMessage: 'This is an estimate of your total balance.',
    id: 'mercury.tooltip_sidebar_total_balance'
  },
  tooltip_simple_trade_cta: {
    defaultMessage: 'The easy way to buy and sell',
    id: 'mercury.tooltip_simple_trade_cta'
  },
  tooltip_ticket_field_amount: {
    defaultMessage: 'Total number of coins you want to trade.',
    id: 'mercury.tooltip_ticket_field_amount'
  },
  tooltip_ticket_field_limitprice: {
    defaultMessage: 'The least favourable price you are willing to accept for the pair.',
    id: 'mercury.tooltip_ticket_field_limitprice'
  },
  tooltip_ticket_field_limitpricestoplimit: {
    defaultMessage: 'The minimum price you’re willing to sell once your order is triggered.',
    id: 'mercury.tooltip_ticket_field_limitpricestoplimit'
  },
  tooltip_ticket_field_min_amt: {
    defaultMessage: 'The order will only execute if the specified minimum amount can be filled.',
    id: 'mercury.tooltip_ticket_field_min_amt'
  },
  tooltip_ticket_field_postonly: {
    defaultMessage:
      'A post only order ensures you will only be the maker side of a trade and pay the maker fee. A post only order type has less of a chance of being filled.',
    id: 'mercury.tooltip_ticket_field_postonly_maker_side'
  },
  tooltip_ticket_field_triggerpricestop: {
    defaultMessage: 'The order will be converted to a Market order when this price level is hit.',
    id: 'mercury.tooltip_ticket_field_triggerpricestop'
  },
  tooltip_ticket_field_triggerpricestoplimit: {
    defaultMessage: 'The order will be converted to a Limit order when this price level is hit.',
    id: 'mercury.tooltip_ticket_field_triggerpricestoplimit'
  },
  tooltip_trade_ticket_fillorkill: {
    defaultMessage:
      'The entire order must execute immediately and completely or it will be cancelled',
    id: 'mercury.tooltip_trade_ticket_fillorkill'
  },
  tooltip_trade_ticket_goodtilcancelled: {
    defaultMessage: 'The order will remain in effect for 95 days unless executed or cancelled.',
    id: 'mercury.tooltip_trade_ticket_goodtilcancelled'
  },
  tooltip_trade_ticket_goodtildate: {
    defaultMessage: 'The order will remain in effect until  the date selected. ',
    id: 'mercury.tooltip_trade_ticket_goodtildate'
  },
  tooltip_trade_ticket_immediateorcancel: {
    defaultMessage: 'Any portion of the order that does not fill immediately will be cancelled. ',
    id: 'mercury.tooltip_trade_ticket_immediateorcancel'
  },
  tooltip_trade_ticket_limit: {
    defaultMessage: 'An order to buy or sell at a specific price or better.',
    id: 'mercury.tooltip_trade_ticket_limit'
  },
  tooltip_trade_ticket_market: {
    defaultMessage: 'An order to execute immediately against the best price(s) available',
    id: 'mercury.tooltip_trade_ticket_market'
  },
  tooltip_trade_ticket_postonly: {
    defaultMessage:
      'A post only order is one that will not execute immediately.  If your order can be matched against any other order, it will be cancelled.  Orders that execute as ‘Post Only’ qualify for the lower Maker’ fee.',
    id: 'mercury.tooltip_trade_ticket_postonly'
  },
  tooltip_trade_ticket_stop: {
    defaultMessage:
      'Stop orders are primarily utilized to protect against downside risk. They allow you to exit your position once the market reaches a specified price, known as the Trigger price. When the stop price is reached, it triggers a market order to sell.',
    id: 'mercury.tooltip_trade_ticket_stop'
  },
  tooltip_trade_ticket_stoplimit: {
    defaultMessage:
      'Stop limit orders can protect  against downside risk via a sell order.  A stop limit order triggers a limit order to sell once the trigger price is reached.',
    id: 'mercury.tooltip_trade_ticket_stoplimit'
  },
  tooltip_trades_amount: {
    defaultMessage: 'Size of execution.',
    id: 'mercury.tooltip_trade_amount'
  },
  tooltip_trades_price: {
    defaultMessage: 'Price the order filled.',
    id: 'mercury.tooltip_trade_price'
  },
  tooltip_trades_time: {
    defaultMessage: 'The time the execution occurred.',
    id: 'mercury.tooltip_trade_time'
  },
  total: {
    defaultMessage: 'Total',
    id: 'mercury.total'
  },
  total_account_value: {
    defaultMessage: 'Total Account Value',
    id: 'mercury.total_account_value'
  },
  total_estimate: {
    defaultMessage: 'Estimated total',
    id: 'mercury.total_estimate'
  },
  trade: {
    defaultMessage: 'Trade',
    id: 'mercury.trade'
  },
  trade_blocked: {
    defaultMessage: 'Trading not allowed',
    id: 'mercury.trade_blocked'
  },
  trade_history: {
    defaultMessage: 'Trade History',
    id: 'mercury.trade_history'
  },
  trades: {
    defaultMessage: 'Trades',
    id: 'mercury.trades'
  },
  trading_preferences: {
    defaultMessage: 'Trading Preferences',
    id: 'mercury.trading_preferences'
  },
  trading_restricted: {
    defaultMessage: 'Trading Restricted',
    id: 'mercury.trading_restricted'
  },
  transaction_id: {
    defaultMessage: 'Transaction ID',
    id: 'mercury.transaction_id'
  },
  try_again: {
    defaultMessage: 'Hit the button below to try again.',
    id: 'mercury.try_again'
  },
  try_different_bank: {
    defaultMessage: 'Try a Different Bank',
    id: 'mercury.try_different_bank'
  },
  try_enable_webcam: {
    defaultMessage:
      'You might need to enable your web cam to upload a video proving you’re not a robot.',
    id: 'mercury.try_enable_webcam'
  },
  two_factor_auth: {
    defaultMessage: 'Two-Factor Authentication',
    id: 'mercury.two_factor_auth'
  },
  two_factor_auth_current: {
    defaultMessage: 'You have {type}, to disable enter code',
    id: 'mercury.two_factor_auth_current'
  },
  two_factor_auth_desc: {
    defaultMessage:
      'Protect your account and your funds by adding a second authentication method. Each time you login or initiate a withdrawal, you will be asked for your password and authentication code.',
    id: 'mercury.two_factor_auth_desc'
  },
  two_factor_auth_setup_description_1: {
    defaultMessage: 'Use an Authenticator app, Yubikey, or SMS Codes',
    id: 'mercury.two_factor_auth_setup_description_1'
  },
  two_factor_auth_setup_description_2: {
    defaultMessage:
      'Two-Factor Authentication helps to prevent unauthorized access to your account by requiring a one-time password for every login and withdrawal attempt.',
    id: 'mercury.two_factor_auth_setup_description_2'
  },
  two_factor_required_for_this: {
    defaultMessage:
      'In order to perform this action you first need to setup a second factor for authentication. Click {link} to set it up.',
    id: 'mercury.two_factor_required_for_this'
  },
  type: {
    defaultMessage: 'Type',
    id: 'mercury.type'
  },
  unlimited: {
    defaultMessage: 'Unlimited',
    id: 'mercury.unlimited'
  },
  unlimited_trading: {
    defaultMessage: 'Unlimited trading',
    id: 'mercury.unlimited_trading'
  },
  unlock_gold_apply: {
    defaultMessage: 'Apply for Full Access Now',
    id: 'mercury.unlock_gold_apply-1'
  },
  unlock_gold_description: {
    defaultMessage:
      'In order to deposit and withdraw {currency}, we need you to unlock Full Access level first.',
    id: 'mercury.unlock_gold_description-1'
  },
  unlock_gold_description_no_currency: {
    defaultMessage:
      'In order to deposit and withdraw, we need you to unlock Full Access level first.',
    id: 'mercury.unlock_gold_description_no_currency'
  },
  unlock_gold_description_withdraw: {
    defaultMessage: 'In order to withdraw {currency}, we need you to unlock Full Access level.',
    id: 'mercury.unlock_gold_description_withdraw-1'
  },
  unlock_gold_learn: {
    defaultMessage: 'To learn more about each level,',
    id: 'mercury.unlock_gold_learn'
  },
  unlock_gold_settings: {
    defaultMessage: 'View Settings',
    id: 'mercury.unlock_gold_settings'
  },
  unlock_gold_title: {
    defaultMessage: 'Apply for Full Access. Unlock Deposits and Withdrawals for {currency}.',
    id: 'mercury.unlock_gold_title-1'
  },
  unlock_margin_cta: {
    defaultMessage: 'Verify Now',
    id: 'mercury.unlock_margin_cta'
  },
  unlock_margin_subtitle: {
    defaultMessage: 'Trade with margin to increase your trading power and investment potential.',
    id: 'mercury.unlock_margin_subtitle'
  },
  unlock_margin_title: {
    defaultMessage: 'Verify Your Account for Margin',
    id: 'mercury.unlock_margin_title'
  },
  unrealised_pnl_1: {
    defaultMessage: 'Un PNL',
    id: 'mercury.unrealised_pnl_1'
  },
  upgrade: {
    defaultMessage: 'Upgrade',
    id: 'mercury.upgrade'
  },
  upgrade_to_gold: {
    defaultMessage: 'Upgrade to Full Access',
    id: 'mercury.upgrade_to_gold-1'
  },
  upgrade_your_exchange_account: {
    defaultMessage: 'Upgrade Your Exchange Account',
    id: 'mercury.upgrade_your_exchange_account'
  },
  upgrade_your_exchange_account_desc: {
    defaultMessage:
      'Blockchain.com offers two types of Account Limits, each designed to suit your crypto goals and needs.',
    id: 'mercury.upgrade_your_exchange_account_desc'
  },
  use_max: {
    defaultMessage: 'Use Max',
    id: 'mercury.use_max'
  },
  use_min: {
    defaultMessage: 'Use Min',
    id: 'mercury.use_min'
  },
  use_of_account_information: {
    defaultMessage: 'Use of Account Information',
    id: 'mercury.use_of_account_information'
  },
  valid_drivers_license: {
    defaultMessage: 'Valid Driver’s License',
    id: 'mercury.valid_drivers_license'
  },
  validation_difference_in_years: {
    defaultMessage: 'Must be at least {difference}',
    id: 'mercury.validation_difference_in_years'
  },
  validation_different_value: {
    defaultMessage: 'Please enter a different value',
    id: 'mercury.validation_different_value'
  },
  validation_email: {
    defaultMessage: 'Must be a valid email address',
    id: 'mercury.validation_email'
  },
  validation_equal_length: {
    defaultMessage: 'Must be {length} characters',
    id: 'mercury.validation_equal_length'
  },
  validation_greater_than: {
    defaultMessage: '{a} must be greater than {b}',
    id: 'mercury.validation_greater_than'
  },
  validation_has_no_spaces: {
    defaultMessage: 'Whitespaces are not allowed',
    id: 'mercury.validation_has_no_spaces'
  },
  validation_ip_address: {
    defaultMessage: 'Invalid IP Address(es)',
    id: 'mercury.validation_ip_address'
  },
  validation_is_greater_than_max: {
    defaultMessage: '{value} is greater than {field}',
    id: 'mercury.validation_is_greater_than_max'
  },
  validation_is_length: {
    defaultMessage: '{field} must have {value} characters',
    id: 'mercury.validation_is_length'
  },
  validation_is_less_than_min: {
    defaultMessage: '{field} must be higher than {value}',
    id: 'mercury.validation_is_less_than_min'
  },
  validation_max_amount: {
    defaultMessage: 'The maximum {field} is {maxAmount}.',
    id: 'mercury.validation_max_amount'
  },
  validation_min_amount: {
    defaultMessage: 'The minimum {field} is {minAmount}.',
    id: 'mercury.validation_min_amount'
  },
  validation_must_be_entered: {
    defaultMessage: '{field} must be entered',
    id: 'mercury.validation_must_be_entered'
  },
  validation_name: {
    defaultMessage: 'Must not contain special characters',
    id: 'mercury.validation_name'
  },
  validation_required: {
    defaultMessage: 'Required',
    id: 'mercury.validation_required'
  },
  validation_should_not_match: {
    defaultMessage: 'does not match',
    id: 'mercury.validation_should_not_match'
  },
  validation_smaller_than: {
    defaultMessage: '{a} must be smaller than {b}',
    id: 'mercury.validation_smaller_than'
  },
  validation_x_must_be_lower_than_y: {
    defaultMessage: '{field} must be lower than {value}',
    id: 'mercury.validation_x_must_be_lower_than_y'
  },
  verified: {
    defaultMessage: 'Verified',
    id: 'mercury.verified'
  },
  verified_limits: {
    defaultMessage: 'Verified Limits',
    id: 'mercury.verified_limits'
  },
  verified_limits_description: {
    defaultMessage: 'Pro Level Trading Limits & Features',
    id: 'mercury.verified_limits_description'
  },
  verify_2fa_email_code_label: {
    defaultMessage: 'We just sent you a code via email, please enter it below',
    id: 'mercury.verify_2fa_email_code_label'
  },
  verify_email_notice: {
    defaultMessage: 'Didn’t receive an email?',
    id: 'mercury.verify_email_notice'
  },
  verify_email_spam_warn: {
    defaultMessage: 'This may take up to 2 minutes or check your spam folder.',
    id: 'mercury.verify_email_spam_warn'
  },
  very_strong: {
    defaultMessage: 'Very Strong',
    id: 'mercury.very_strong'
  },
  via_bank: {
    defaultMessage: 'Via Bank',
    id: 'mercury.via_bank'
  },
  via_stablecoins: {
    defaultMessage: 'Via Stablecoins',
    id: 'mercury.via_stablecoins'
  },
  view: {
    defaultMessage: 'View',
    id: 'mercury.view'
  },
  view_docs: {
    defaultMessage: 'View Docs',
    id: 'mercury.view_docs'
  },
  view_whitelisted_addresses: {
    defaultMessage: 'Your Addresses',
    id: 'mercury.view_whitelisted_addresses'
  },
  volume: {
    defaultMessage: 'Volume',
    id: 'mercury.volume'
  },
  volume_24_currency: {
    defaultMessage: '24h Volume ({currency})',
    id: 'mercury.volume_24h_currency'
  },
  waiting_bank_subtitle: {
    defaultMessage: 'Funds should be available in 2 working days or sooner.',
    id: 'mercury.waiting_bank_subtitle1'
  },
  waiting_bank_title: {
    defaultMessage: 'We’re working with {bankName} to process your payment.',
    id: 'mercury.waiting_bank_title1'
  },
  weak: {
    defaultMessage: 'Weak',
    id: 'mercury.weak'
  },
  welcome_1_kyc_needed_subtitle: {
    defaultMessage: 'Verify your identity to start trading.',
    id: 'mercury.welcome_1_kyc_needed_subtitle'
  },
  welcome_1_kyc_needed_title: {
    defaultMessage: 'Tell Us Who You Are',
    id: 'mercury.welcome_1_kyc_needed_title'
  },
  welcome_1_subtitle: {
    defaultMessage: 'As you trade more per month, you’ll qualify for lower and lower fees.',
    id: 'mercury.welcome_1_subtitle'
  },
  welcome_1_title: {
    defaultMessage: 'Trade More with Low Fees',
    id: 'mercury.welcome_1_title'
  },
  welcome_2_subtitle: {
    defaultMessage: 'Over 80 trading pairs including BTC, ETH, DeFi, Stablecoins, and more.',
    id: 'mercury.welcome_2_subtitle'
  },
  welcome_2_title: {
    defaultMessage: 'Top Crypto Trading Pairs',
    id: 'mercury.welcome_2_title'
  },
  welcome_3_subtitle: {
    defaultMessage:
      'Use pro tools like customizable charts, multiple order types, margin trading, and insights backed by institutional-grade research and data.',
    id: 'mercury.welcome_3_subtitle'
  },
  welcome_3_title: {
    defaultMessage: 'Super Powered Trading Tools',
    id: 'mercury.welcome_3_title'
  },
  welcome_title: {
    defaultMessage: 'Welcome to Your New Blockchain.com Exchange Account!',
    id: 'mercury.welcome_title'
  },
  whats_new_modal_button: {
    defaultMessage: 'Trade {currency} Now',
    id: 'mercury.whats_new_modal_button'
  },
  whats_new_modal_subtitle: {
    defaultMessage:
      'Exchange, deposit, withdraw, or store {currency} in your Blockchain.com Exchange account.',
    id: 'mercury.whats_new_modal_subtitle'
  },
  whats_new_modal_title: {
    defaultMessage: '{currency} is Now Available',
    id: 'mercury.whats_new_modal_title'
  },
  whitelist_address: {
    defaultMessage: 'Whitelist Address',
    id: 'mercury.whitelist_address'
  },
  whitelist_address_desc: {
    defaultMessage: 'Address Description',
    id: 'mercury.whitelist_address_desc'
  },
  whitelist_disable: {
    defaultMessage: 'Disable Whitelisting',
    id: 'mercury.whitelist_disable'
  },
  whitelist_disable_point_one: {
    defaultMessage: 'No access to whitelist address API',
    id: 'mercury.whitelist_disable_point_one'
  },
  whitelist_disable_point_two: {
    defaultMessage: 'Your 2FA code will be required for all withdrawals',
    id: 'mercury.whitelist_disable_point_two'
  },
  whitelisted_addresses: {
    defaultMessage: 'Address Whitelisting',
    id: 'mercury.whitelisted_addresses'
  },
  whitelisted_addresses_none: {
    defaultMessage: 'You don’t have any whitelisted addresses.',
    id: 'mercury.whitelisted_addresses_none'
  },
  whitelisting_enable: {
    defaultMessage: 'Enable Whitelisting',
    id: 'mercury.whitelisting_enable'
  },
  whitelisting_manage: {
    defaultMessage: 'Manage Whitelisted Addresses',
    id: 'mercury.whitelisting_manage'
  },
  whitelisting_manage_sub_title: {
    defaultMessage: 'My Whitelisted Addresses',
    id: 'mercury.whitelisting_manage_sub_title'
  },
  whitelisting_menu_add: {
    defaultMessage: 'Add New',
    id: 'mercury.whitelisting_menu_add'
  },
  whitelisting_menu_disable: {
    defaultMessage: 'Disable',
    id: 'mercury.whitelisting_menu_disable'
  },
  whitelisting_menu_manage: {
    defaultMessage: 'Manage',
    id: 'mercury.whitelisting_menu_manage'
  },
  whitelisting_setup_point: {
    defaultMessage: 'Withdraw crypto to whitelisted addresses using our web interface or API.',
    id: 'mercury.whitelisting_setup_point'
  },
  whitelisting_setup_point2: {
    defaultMessage:
      'We require 2FA when adding a new address but not for withdrawing to a whitelisted address.',
    id: 'mercury.whitelisting_setup_point2'
  },
  wire_fee: {
    defaultMessage: 'Withdrawal Fee',
    id: 'mercury.wire_fee1'
  },
  wire_instructions: {
    defaultMessage: 'Wire Instructions',
    id: 'mercury.wire_instructions'
  },
  wire_transfer: {
    defaultMessage: 'Wire Transfer',
    id: 'mercury.wire_transfer'
  },
  wire_transfer_disclaimer: {
    defaultMessage:
      'Send funds directly from your bank account to your Exchange account. Bank fees may apply.',
    id: 'mercury.wire_transfer_disclaimer'
  },
  withdraw: {
    defaultMessage: 'Withdraw',
    id: 'mercury.withdraw'
  },
  withdraw_address_sub_dec_one: {
    defaultMessage:
      'Only allow withdrawals to addresses you have added to your appproved whitelist.',
    id: 'mercury.withdraw_address_sub_dec_one1'
  },
  withdraw_address_sub_dec_three: {
    defaultMessage: 'We require 2FA when adding a new address but not for whitelisted addresses.',
    id: 'mercury.withdraw_address_sub_dec_three'
  },
  withdraw_address_sub_dec_two: {
    defaultMessage: 'Withdraw crypto from whitelisted addresses using our web interface or API.',
    id: 'mercury.withdraw_address_sub_dec_two'
  },
  withdraw_balance: {
    defaultMessage: 'Your withdrawable balance',
    id: 'mercury.withdraw_balance'
  },
  withdraw_currency: {
    defaultMessage: 'Withdraw {currency}',
    id: 'mercury.withdraw_currency'
  },
  withdraw_history: {
    defaultMessage: 'Withdraw History',
    id: 'mercury.withdraw_history'
  },
  withdraw_min: {
    defaultMessage: 'Min Withdraw',
    id: 'mercury.withdraw_min'
  },
  withdraw_stablecoins: {
    defaultMessage: 'Withdraw Stablecoins',
    id: 'mercury.withdraw_stablecoins'
  },
  withdraw_title: {
    defaultMessage: 'Withdraw',
    id: 'mercury.withdraw_title'
  },
  withdraw_via_bank: {
    defaultMessage: 'Withdraw Via Bank',
    id: 'mercury.withdraw_via_bank'
  },
  withdrawal_fee_amount_1: {
    defaultMessage: 'The fee for this transaction is {fee}',
    id: 'mercury.withdrawal_fee_amount_1'
  },
  withdrawal_fee_amount_2: {
    defaultMessage:
      'There is a {fee} transaction fee for all {currency} withdrawals. You are withdrawing {withdrawal} {currency}.',
    id: 'mercury.withdrawal_fee_amount_2'
  },
  withdrawal_limits_annual: {
    defaultMessage: 'Annual Withdrawal Limits',
    id: 'mercury.withdrawal_limits_annual'
  },
  withdrawal_limits_desc: {
    defaultMessage: '{type} withdrawals up to',
    id: 'mercury.withdrawal_limits_desc'
  },
  withdrawal_limits_weekly: {
    defaultMessage: 'Weekly Withdrawal Limits',
    id: 'mercury.withdrawal_limits_weekly'
  },
  withdrawal_success_crypto1: {
    defaultMessage:
      'A withdrawal of {value} is being processed. It might take a few hours to confirm based on network activity.',
    id: 'mercury.withdrawal_success_crypto1'
  },
  withdrawal_success_crypto2: {
    defaultMessage:
      'A withdrawal of {value} is being processed. It might take a few hours to confirm based on network activity. {trxLink} to view the status of the transaction.',
    id: 'mercury.withdrawal_success_crypto2'
  },
  withdrawal_success_fiat1: {
    defaultMessage:
      'Your withdrawal of {value} has been started and should be available in your Bank Account in 5 business days',
    id: 'mercury.withdrawal_success_fiat1'
  },
  withdrawal_time: {
    defaultMessage: 'Withdrawal time',
    id: 'mercury.withdrawal_time'
  },
  withdrawal_upgrade: {
    defaultMessage: 'Apply for Full Access to trade larger amounts',
    id: 'mercury.withdrawal_upgrade-2'
  },
  withdrawals: {
    defaultMessage: 'Withdrawals',
    id: 'mercury.withdrawals'
  },
  withdrawl_currency: {
    defaultMessage: 'Withdrawal {currency}',
    id: 'mercury.withdrawl_currency'
  },
  yes: {
    defaultMessage: 'Yes',
    id: 'mercury.yes'
  },
  yodlee_splash_body_subtitle: {
    defaultMessage:
      'Yodlee securely stores your credentials adhering to leading industry practices for data security, regulatory compliance, and privacy. {link}',
    id: 'mercury.yodlee_splash_body_subtitle'
  },
  yodlee_splash_body_title: {
    defaultMessage: 'Secure Connection',
    id: 'mercury.yodlee_splash_body_title'
  },
  yodlee_splash_subtitle: {
    defaultMessage:
      'Blockchain.com uses Yodlee to verify your bank credentials & securely link your accounts. link your bank.',
    id: 'mercury.yodlee_splash_subtitle'
  },
  yodlee_splash_title: {
    defaultMessage: 'Link a Bank Account',
    id: 'mercury.yodlee_splash_title'
  },
  you_have_zero: {
    defaultMessage: 'You have zero {currency}',
    id: 'mercury.you_have_zero'
  },
  youll_need_docs: {
    defaultMessage: 'You’ll need one of the following docs to verify.',
    id: 'mercury.youll_need_docs'
  },
  your_api_keys: {
    defaultMessage: 'Your API Keys',
    id: 'mercury.your_api_keys'
  },
  your_limits_and_fees: {
    defaultMessage: 'Your Limits & Features',
    id: 'mercury.your_limits_and_fees'
  },
  your_max_balance: {
    defaultMessage: 'You cannot buy more than your balance of {balance}',
    id: 'mercury.your_max_balance'
  },
  your_max_of: {
    defaultMessage: 'your max of',
    id: 'mercury.your_max_of'
  },
  yubikey: {
    defaultMessage: 'Yubikey',
    id: 'mercury.yubikey'
  },
  yubikey_code: {
    defaultMessage: 'Yubikey code',
    id: 'mercury.yubikey_code'
  },
  yubikey_desc: {
    defaultMessage: 'Pair with your Yubikey',
    id: 'mercury.yubikey_desc'
  },
  yubikey_setup_step1: {
    defaultMessage: "Insert the Yubikey into your computer's USB port.",
    id: 'mercury.yubikey_setup_step1'
  },
  yubikey_setup_step2: {
    defaultMessage: 'Pair your Yubikey.',
    id: 'mercury.yubikey_setup_step2'
  },
  zero: {
    defaultMessage: 'Zero',
    id: 'mercury.zero'
  }
})
